<script src="https://unpkg.com/select2@4.0.3/dist/js/select2.js"></script>

<link rel="stylesheet" type="text/css" href="https://unpkg.com/select2@4.0.3/dist/css/select2.min.css" />
<template>
    <div class="mt-2 mb-4">
        <b-row style="margin: auto;">
            <div class="col-md-12 mt-3 mb-3">
                <b-row class="my-1">
                    <b-col sm="12" class="align-items-center d-flex justify-content-left">
                        <h4 class="" style="color:black;"
                            v-html="this.modelData['outcome_type_model']['outcome_type'] + '</br> ' + this.modelData['model']['outcome_code'] + ': ' + this.modelData['model']['outcome_name']">
                        </h4>
                    </b-col>
                </b-row>
            </div>
        </b-row>
        <b-row style="background-color:#6C6C6C; margin: auto;">
            <div class="col-md-12 mt-3 mb-3" style="background-color:#6C6C6C;">
                <b-row class="my-1 align-items-center d-flex justify-content-center">
                    <b-col sm="6" class="text-left">
                        <p style="color:#FFFFFF; font-family:roboto; font-size:22px;" class="mt-2">Secretariat Reporting
                        </p>
                    </b-col>
                    <b-col sm="6" class="text-right mt-1">
                        <b-row>
                            <b-col sm="6" class="text-right">
                                <label class="" style="font-family:roboto; color:#FFFFFF; font-size: 17px;">Select
                                    reporting period</label>
                            </b-col>
                            <b-col sm="6" class="text-left">
                                <b-form-select @change="loadReport" v-model="model.period_id" size="sm" required
                                    style="border-radius: unset;" class="col-xl-12">
                                    <option value="">-- none --</option>
                                    <option v-for="period in modelData['reporting_period']" v-bind:key="period"
                                        :value="period.id">{{ period.period }}
                                    </option>
                                </b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </div>
        </b-row>
        <div v-bind:hidden="hideTabs" class="mt-4 mb-3">
            <b-tabs pills card vertical class="tabs">
                <b-form ref="form" @submit.prevent="saveEditReports()">
                    <b-row class="mt-4">
                        <b-container>
                            <b-tab no-nav-style active class="mb-4">
                                <template v-slot:title>
                                    <h6 class="mt-3"
                                        style="font-weight: 600; font-size:17px; font-family:roboto; color:#1D1D1D;">
                                        OUTCOME TYPE</h6>
                                </template>
                                <b-card-text>
                                    <b-col>
                                        <b-row>
                                            <b-col>
                                                <h5 class="mheader"
                                                    style="font-weight: 600; font-family:Roboto; color:#202020;">Outcome
                                                    Type</h5>
                                                <span style="font-family:roboto; font-size:18px;"
                                                    v-html="this.modelData['outcome_type_model']['outcome_type']" />
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card-text>
                                <b-card-text>
                                    <b-col>
                                        <b-row>
                                            <b-col>
                                                <h5 class="mheader"
                                                    style="font-weight:600; font-family:Roboto; color:#202020;">Summary
                                                </h5>
                                                <span style="font-family:roboto; font-size:18px;"
                                                    v-html="modelData['model']['outcome_summary']" />
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card-text>
                                <b-card-text>
                                    <b-col>
                                        <b-row>
                                            <b-col>
                                                <h5 class="mheader"
                                                    style="font-weight: 600; font-family:Roboto; color:#202020;">
                                                    Executive
                                                    Director's Mandate</h5>
                                                <span style="font-family:roboto; font-size:18px;"
                                                    v-html="modelData['model']['ed_mandate']" />
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card-text>
                            </b-tab>
                            <b-tab class="mb-4">
                                <template v-slot:title class="">
                                    <h6 class="mb-2 mt-3"
                                        style="font-weight: 600; font-size:17px; font-family:roboto; color:#1D1D1D;">
                                        IMPLEMENTATION PLAN</h6>
                                </template>
                                <b-card-text>
                                    <b-col>
                                        <b-row>
                                            <b-col sm="12">
                                                <h5 class=""
                                                    style="font-weight: 600; font-family:Roboto; color:#202020;">
                                                    Implementation Plan</h5>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card-text>
                                <b-card-text>
                                    <br />
                                    <table class="table dataTable table-bordered" id="implementationplans_table">
                                        <thead>
                                            <tr>
                                                <th width="85%">Implementation Plan</th>
                                                <th width="15%">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in implementationplans_data" :key="item.id">
                                                <td>{{ item.implementationplan }}</td>
                                                <td> <a v-bind:href="'/editimplementationplan/' + item.id"
                                                        class="implementationplanedit" id="item.id"
                                                        @click.stop="editImplementationplan(item.id)">Edit </a> |
                                                    <a v-bind:href="'/deleteimplementationplan/' + item.id"
                                                        class="implementationplandelete" id="item.id"
                                                        @click.stop="deleteImplementationplan(item.id)">Delete </a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <br />
                                    <b-button ref="addImplementationplan" id="addImplementationplan"
                                        style="margin-left: 15px;" @click="showImplementationplanModal"
                                        v-show="implementationplans_data.length < 1">Add Implementation
                                        Plan</b-button>
                                    <b-modal ref="mdl-addImplementationplan" id="mdl-addImplementationplan" hide-footer
                                        title="Add Implementation Plan">
                                        <div>
                                            <form ref="form" @submit.prevent="addImplementationplan()">
                                                <b-row>
                                                    <b-col class="col-md-4"> Implementation Plan: </b-col>
                                                    <b-col class="col-md-8"> <textarea required class="col-md-12"
                                                            name="implementationplan" id="implementationplan"
                                                            v-model="implementationplan"
                                                            @keyup="CountWords(implementationplan, 'implementationplantotalwords', 'addimplementationplan')"
                                                            rows="10"></textarea> <br /> <span
                                                            id="implementationplantotalwords"></span></b-col>
                                                </b-row>
                                                <b-button id="addimplementationplan" class=" btn-primary"
                                                    type="submit">Save</b-button>
                                            </form>

                                        </div>
                                    </b-modal>
                                    <b-modal ref="mdl-editImplementationplan" id="mdl-editImplementationplan"
                                        hide-footer title="Edit Implementationplan">
                                        <div>
                                            <form ref="form" @submit.prevent="modifyImplementationplan()">
                                                <b-row>
                                                    <b-col class="col-md-4"> Implementation Plan: </b-col>
                                                    <b-col class="col-md-8"> <textarea required class="col-md-12"
                                                            name="implementationplan" id="implementationplan"
                                                            v-model="implementationplan"
                                                            @keyup="CountWords(implementationplan, 'implementationplantotalwords', 'editImplementationplan')"
                                                            rows="10"></textarea> <br /> <span
                                                            id="implementationplantotalwords"></span></b-col>
                                                </b-row>
                                                <b-button id="editImplementationplan" type="submit">Save</b-button>
                                            </form>

                                        </div>
                                    </b-modal>
                                    <b-modal ref="mdl-deleteImplementationplan" id="mdl-deleteImplementationplan"
                                        hide-footer title="Delete Implementationplan">
                                        <div>
                                            <form ref="form" @submit.prevent="delImplementationplan()">

                                                <br />
                                                <b-row>
                                                    <b-col class="col-md-6"> Are you sure you want to Delete? </b-col>
                                                </b-row>
                                                <br />
                                                <b-row>
                                                    <b-col class="col-md-2">
                                                        <b-button id="deleteImplementationplan"
                                                            @click="hidedeleteImplementationplanModal">NO</b-button>
                                                    </b-col>
                                                    <b-col class="col-md-5 col-md-offset-1">
                                                        <b-button id="deleteImplementationplan"
                                                            type="submit">YES</b-button>
                                                    </b-col>
                                                </b-row>
                                            </form>

                                        </div>
                                    </b-modal>
                                </b-card-text>
                            </b-tab>
                            <b-tab class="mb-4">
                                <template v-slot:title>
                                    <h6 class="mb-2 mt-3"
                                        style="font-weight: 600; font-size:17px; font-family:roboto; color:#1D1D1D;">
                                        MILESTONES</h6>
                                </template>
                                <br />
                                <table class="table dataTable table-bordered" id="milestones_table">
                                    <thead>
                                        <tr>
                                            <th width="25%">Milestone Status</th>
                                            <th width="60%">Milestone </th>
                                            <th width="15%">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in milestones_data" :key="item.id">
                                            <td>{{ item.status_name }}</td>
                                            <td>{{ item.milestone_text }}</td>
                                            <td> <a v-bind:href="'/editmilestone/' + item.id" class="milestoneedit"
                                                    id="item.id" @click.stop="editMilestone(item.id)">Edit </a> |
                                                <a v-bind:href="'/deletemilestone/' + item.id" class="milestonedelete"
                                                    id="item.id" @click.stop="deleteMilestone(item.id)">Delete </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <br />
                                <div v-if="milestones_data != null">
                                    <b-button ref="addMilestone" style="margin-left: 15px;" @click="showMilestoneModal"
                                        v-show="milestones_data.length < 4">Add Milestone</b-button>
                                </div>
                                <div v-else="">
                                    <b-button ref="addMilestone" style="margin-left: 15px;"
                                        @click="showMilestoneModal">Add Milestone</b-button>
                                </div>

                                <b-modal ref="mdl-addMilestone" id="mdl-addMilestone" hide-footer title="Add Milestone">
                                    <div>
                                        <form ref="form" @submit.prevent="addMilestone()">
                                            <b-row>
                                                <b-col class="col-md-4"> Milestone Status </b-col>
                                                <b-col class="col-md-8">
                                                    <select required name=" " id="milestone_status_id" class="col-md-9"
                                                        v-model="milestone_status_id">
                                                        <option>---Select Status---</option>
                                                        <option value="1">Attained</option>
                                                        <option value="2">Partialy Attained</option>
                                                        <option value="3">Not Attained</option>
                                                    </select>
                                                </b-col>
                                            </b-row>
                                            <br />
                                            <b-row>
                                                <b-col class="col-md-4"> Milestone : </b-col>
                                                <b-col class="col-md-8"> <textarea required class="col-md-9"
                                                        name="milestone_text" id="milestone_text"
                                                        v-model="milestone_text"
                                                        @keyup="CountWords(milestone_text, 'milestone_texttotalwords', 'addmilestone')"
                                                        rows="10"></textarea> <br /> <span
                                                        id="milestone_texttotalwords"></span> </b-col>

                                            </b-row>
                                            <b-button id="addmilestone" class=" btn-primary"
                                                type="submit">Save</b-button>
                                        </form>

                                    </div>
                                </b-modal>
                                <b-modal ref="mdl-editMilestone" id="mdl-editMilestone" hide-footer
                                    title="Edit Milestone">
                                    <div>
                                        <form ref="form" @submit.prevent="modifyMilestone()">
                                            <b-row>
                                                <b-col class="col-md-4"> Milestone Status </b-col>
                                                <b-col class="col-md-8">
                                                    <select required name=" " id="milestone_status_id" class="col-md-9"
                                                        v-model="milestone_status_id">
                                                        <option>---Select Status---</option>
                                                        <option value="1">Attained</option>
                                                        <option value="2">Partialy Attained</option>
                                                        <option value="3">Not Attained</option>

                                                    </select>
                                                </b-col>
                                            </b-row>
                                            <br />
                                            <b-row>
                                                <b-col class="col-md-4"> Milestone : </b-col>
                                                <b-col class="col-md-8"> <textarea required class="col-md-9"
                                                        name="milestone_text" id="milestone_text"
                                                        v-model="milestone_text"
                                                        @keyup="CountWords(milestone_text, 'milestone_texttotalwords', 'editMilestone')"
                                                        rows="10"></textarea> <br /> <span
                                                        id="milestone_texttotalwords"></span> </b-col>

                                            </b-row>


                                            <b-button id="editMilestone" type="submit">Save</b-button>
                                        </form>

                                    </div>
                                </b-modal>

                                <b-modal ref="mdl-deleteMilestone" id="mdl-deleteMilestone" hide-footer
                                    title="Delete Milestone">
                                    <div>
                                        <form ref="form" @submit.prevent="delMilestone()">

                                            <br />
                                            <b-row>
                                                <b-col class="col-md-6"> Are you sure you want to Delete? </b-col>
                                            </b-row>
                                            <br />
                                            <b-row>
                                                <b-col class="col-md-2">
                                                    <b-button id="deleteMilestone"
                                                        @click="hidedeleteMilestoneModal">NO</b-button>
                                                </b-col>
                                                <b-col class="col-md-5 col-md-offset-1">
                                                    <b-button id="deleteMilestone" type="submit">YES</b-button>
                                                </b-col>
                                            </b-row>
                                        </form>
                                    </div>
                                </b-modal>
                            </b-tab>
                            <b-tab class="mb-4">
                                <template v-slot:title>
                                    <h6 class="mb-2 mt-3"
                                        style="font-weight: 600; font-size:17px; font-family:roboto; color:#1D1D1D;">
                                        RESULTS</h6>
                                </template>
                                <br />
                                <table class="table dataTable table-bordered" id="results_table">
                                    <thead>
                                        <tr>
                                            <th width="25%">Result Category</th>
                                            <th width="60%">Result Highlights</th>
                                            <th width="15%">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in results_data" :key="item.id">
                                            <td>{{ item.result_category_id }}</td>
                                            <td>{{ item.result_text }}</td>
                                            <td> <a v-bind:href="'/editresult/' + item.id" class="resultedit"
                                                    id="item.id" @click.stop="editResult(item.id)">Edit </a> | <a
                                                    v-bind:href="'/deleteresult/' + item.id" class="resultdelete"
                                                    id="item.id" @click.stop="deleteResult(item.id)">Delete </a></td>
                                        </tr>
                                    </tbody>
                                </table>
                                <br />
                                <div v-if="results_data != null">
                                    <b-button ref="addResult" style="margin-left: 15px;" @click="showResultModal"
                                        v-show="results_data.length < 4">Add Result</b-button>
                                </div>
                                <div v-else="">
                                    <b-button ref="addResult" style="margin-left: 15px;" @click="showResultModal">Add
                                        Result</b-button>
                                </div>

                                <b-modal ref="mdl-addResult" id="mdl-addResult" hide-footer title="Add Result">
                                    <div>
                                        <form ref="form" @submit.prevent="addResult()">
                                            <b-row>
                                                <b-col class="col-md-4"> Result Category </b-col>
                                                <b-col class="col-md-8">
                                                    <select required name="result_category_id" id="result_category_id"
                                                        v-model="result_category_id">
                                                        <option>---Select Category---</option>
                                                        <option v-for="option in result_categories">{{ option }}
                                                        </option>
                                                    </select>
                                                </b-col>
                                            </b-row>
                                            <br />
                                            <b-row>
                                                <b-col class="col-md-4"> Result Highlights: </b-col>
                                                <b-col class="col-md-8"> <textarea required class="col-md-9"
                                                        name="result_text" id="result_text" rows="10"
                                                        v-model="result_text"
                                                        @keyup="CountWords(result_text, 'resultotalwords', 'addresult')"></textarea>
                                                    <br /> <span id="resultotalwords"> </span></b-col>

                                            </b-row>
                                            <b-button id="addresult" class=" btn-primary" type="submit">Save</b-button>
                                        </form>

                                    </div>
                                </b-modal>
                                <b-modal ref="mdl-editResult" id="mdl-editResult" hide-footer title="Edit Result">
                                    <div>
                                        <form ref="form" @submit.prevent="modifyResult()">
                                            <b-row>
                                                <b-col class="col-md-4"> Result Category </b-col>
                                                <b-col class="col-md-8">
                                                    <select required name="result_category_id" id="result_category_id"
                                                        v-model="result_category_id">
                                                        <option>---Select Status---</option>
                                                        <option v-for="option in result_categories">{{ option }}
                                                        </option>
                                                    </select>
                                                </b-col>
                                            </b-row>
                                            <br />
                                            <b-row>
                                                <b-col class="col-md-4"> Result Highlights: </b-col>
                                                <b-col class="col-md-8"> <textarea required class="col-md-9"
                                                        name="result_text" id="result_text" rows="10"
                                                        v-model="result_text"
                                                        @keyup="CountWords(result_text, 'resultotalwords', 'editResult')"></textarea>
                                                    <br /> <span id="resultotalwords"> </span></b-col>

                                            </b-row>


                                            <b-button id="editResult" type="submit">Save</b-button>
                                        </form>

                                    </div>
                                </b-modal>

                                <b-modal ref="mdl-deleteResult" id="mdl-deleteResult" hide-footer title="Delete Result">
                                    <div>
                                        <form ref="form" @submit.prevent="delResult()">

                                            <br />
                                            <b-row>
                                                <b-col class="col-md-6"> Are you sure you want to Delete? </b-col>
                                            </b-row>
                                            <br />
                                            <b-row>
                                                <b-col class="col-md-2">
                                                    <b-button id="deleteResult"
                                                        @click="hidedeleteResultModal">NO</b-button>
                                                </b-col>
                                                <b-col class="col-md-5 col-md-offset-1">
                                                    <b-button id="deleteResult" type="submit">YES</b-button>
                                                </b-col>
                                            </b-row>
                                        </form>

                                    </div>
                                </b-modal>
                            </b-tab>
                            <b-tab class="mb-4">
                                <template v-slot:title>
                                    <h6 class="mb-2 mt-3"
                                        style="font-weight: 600; font-size:17px; font-family:roboto; color:#1D1D1D;">
                                        RESOURCES</h6>
                                </template>
                                <b-card-text>
                                    <b-col>
                                        <b-row>
                                            <b-col>
                                                <h5 style="font-weight: 600; font-family:Roboto; color:#202020;">
                                                    Resources
                                                </h5>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card-text>
                                <b-card-text>
                                    <br />
                                    <table class="table dataTable table-bordered" id="resources_table">
                                        <thead>
                                            <tr>
                                                <th>Resource Category</th>
                                                <th>Description</th>
                                                <th>Resource Category</th>
                                                <th>Description</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in resources_data" :key="item.id">
                                                <td>{{ item.resource_category_id1 }}</td>
                                                <td>{{ item.resource1 }}</td>
                                                <td>{{ item.resource_category_id2 }}</td>
                                                <td>{{ item.resource2 }}</td>
                                                <td> <a v-bind:href="'/editresource/' + item.id" class="resourceedit"
                                                        id="item.id" @click.stop="editResource(item.id)">Edit </a> | <a
                                                        v-bind:href="'/deleteresource/' + item.id"
                                                        class="resourcedelete" id="item.id"
                                                        @click.stop="deleteResource(item.id)">Delete </a></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <br />
                                    <b-button ref="addResource" id="addResource" style="margin-left: 15px;"
                                        @click="showResourceModal" v-show="resources_data.length < 1">Add
                                        Resource</b-button>
                                    <b-modal ref="mdl-addResource" id="mdl-addResource" hide-footer
                                        title="Add Resource">
                                        <div>
                                            <form ref="form" @submit.prevent="addResource()">
                                                <b-row>
                                                    <b-col class="col-md-4"> Resource Category </b-col>
                                                    <b-col class="col-md-8"> Within Existing Resources</b-col>
                                                </b-row>
                                                <br />
                                                <b-row>
                                                    <b-col class="col-md-4"> Description: </b-col>
                                                    <b-col class="col-md-8"> <textarea required class="col-md-12"
                                                            name="resource1" id="resource1" v-model="resource1"
                                                            @keyup="CountWords(resource1, 'resource1totalwords', 'addresource')"
                                                            rows="10"></textarea> <br /> <span
                                                            id="resource1totalwords"></span></b-col>
                                                </b-row>
                                                <br /><br />
                                                <b-row>
                                                    <b-col class="col-md-4"> Resource Category </b-col>
                                                    <b-col class="col-md-8"> Additional Resources Required </b-col>
                                                </b-row>
                                                <br />
                                                <b-row>
                                                    <b-col class="col-md-4"> Description: </b-col>
                                                    <b-col class="col-md-8"> <textarea required class="col-md-12"
                                                            name="resource2" id="resource2" v-model="resource2"
                                                            @keyup="CountWords(resource2, 'resource2totalwords', 'addresource')"
                                                            rows="10"></textarea> <br /> <span
                                                            id="resource2totalwords"></span> </b-col>
                                                </b-row>
                                                <b-button id="addresource" class=" btn-primary"
                                                    type="submit">Save</b-button>
                                            </form>

                                        </div>
                                    </b-modal>
                                    <b-modal ref="mdl-editResource" id="mdl-editResource" hide-footer
                                        title="Edit Resource">
                                        <div>
                                            <form ref="form" @submit.prevent="modifyResource()">
                                                <b-row>
                                                    <b-col class="col-md-4"> Resource Category </b-col>
                                                    <b-col class="col-md-8"> Within Existing Resources</b-col>
                                                </b-row>
                                                <br /><br />
                                                <b-row>
                                                    <b-col class="col-md-4"> Description: </b-col>
                                                    <b-col class="col-md-8"> <textarea required class="col-md-12"
                                                            name="resource1" id="resource1" v-model="resource1"
                                                            @keyup="CountWords(resource1, 'resource1totalwords', 'editResource')"
                                                            rows="10"></textarea> <br /> <span
                                                            id="resource1totalwords"></span></b-col>
                                                </b-row>
                                                <br /><br />
                                                <b-row>
                                                    <b-col class="col-md-4"> Resource Category </b-col>
                                                    <b-col class="col-md-8"> Additional Resources Required </b-col>
                                                </b-row>
                                                <br />
                                                <b-row>
                                                    <b-col class="col-md-4"> Description: </b-col>
                                                    <b-col class="col-md-8"> <textarea required class="col-md-12"
                                                            name="resource2" id="resource2" v-model="resource2"
                                                            @keyup="CountWords(resource2, 'resource2totalwords', 'editResource')"
                                                            rows="10"></textarea> <br /> <span
                                                            id="resource2totalwords"></span> </b-col>
                                                </b-row>
                                                <b-button id="editResource" type="submit">Save</b-button>
                                            </form>

                                        </div>
                                    </b-modal>
                                    <b-modal ref="mdl-deleteResource" id="mdl-deleteResource" hide-footer
                                        title="Delete Resource">
                                        <div>
                                            <form ref="form" @submit.prevent="delResource()">

                                                <br />
                                                <b-row>
                                                    <b-col class="col-md-6"> Are you sure you want to Delete? </b-col>
                                                </b-row>
                                                <br />
                                                <b-row>
                                                    <b-col class="col-md-2">
                                                        <b-button id="deleteResource"
                                                            @click="hidedeleteResourceModal">NO</b-button>
                                                    </b-col>
                                                    <b-col class="col-md-5 col-md-offset-1">
                                                        <b-button id="deleteResource" type="submit">YES</b-button>
                                                    </b-col>
                                                </b-row>
                                            </form>

                                        </div>
                                    </b-modal>
                                </b-card-text>
                            </b-tab>
                            <b-tab class="mb-4">
                                <template v-slot:title>
                                    <h6 class="mb-2 mt-3"
                                        style="font-weight: 600; font-size:17px; font-family:roboto; color:#1D1D1D;">
                                        LEARNING</h6>
                                </template>
                                <b-card-text>
                                    <b-col>
                                        <b-row>
                                            <b-col>
                                                <h5 style="font-weight: 600; font-family:Roboto; color:#202020;">
                                                    Learning
                                                </h5>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card-text>
                                <b-card-text>
                                    <b-col>
                                        <b-row>
                                            <b-col>
                                                <b-tabs justified pills card nav-wrapper-class="w-40">
                                                    <b-tab active>
                                                        <template v-slot:title>
                                                            <h6 class="mb-0"
                                                                style="font-weight: normal; color:#1D1D1D;">
                                                                Best Practices</h6>
                                                        </template>
                                                        <br />
                                                        <table class="table dataTable table-bordered"
                                                            id="bestpractices_table">
                                                            <thead>
                                                                <tr>
                                                                    <th width="85%">Best Practice</th>
                                                                    <th width="15%">Actions</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="item in bestpractices_data" :best="item.id">
                                                                    <td>{{ item.bestpractice }}</td>
                                                                    <td> <a v-bind:href="'/editbestpractice/' + item.id"
                                                                            class="bestpracticeedit" id="item.id"
                                                                            @click.stop="editBestpractice(item.id)">Edit
                                                                        </a> | <a
                                                                            v-bind:href="'/deletebestpractice/' + item.id"
                                                                            class="bestpracticedelete" id="item.id"
                                                                            @click.stop="deleteBestpractice(item.id)">Delete
                                                                        </a></td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                        <br />
                                                        <b-button ref="addBestpractice" id="addBestpractice"
                                                            style="margin-left: 15px;" @click="showBestpracticeModal"
                                                            v-show="bestpractices_data.length < 1">Add Best
                                                            Practice</b-button>
                                                        <b-modal ref="mdl-addBestpractice" id="mdl-addBestpractice"
                                                            hide-footer title="Add Best Practice">
                                                            <div>
                                                                <form ref="form" @submit.prevent="addBestpractice()">
                                                                    <b-row>
                                                                        <b-col class="col-md-4"> Best Practice: </b-col>
                                                                        <b-col class="col-md-8"> <textarea required
                                                                                class="col-md-12" name="bestpractice"
                                                                                id="bestpractice" v-model="bestpractice"
                                                                                @keyup="CountWords(bestpractice, 'bestpracticetotalwords', 'addbestpractice')"
                                                                                rows="10"></textarea> <br /> <span
                                                                                id="bestpracticetotalwords"></span></b-col>
                                                                    </b-row>
                                                                    <b-button id="addbestpractice" class=" btn-primary"
                                                                        type="submit">Save</b-button>
                                                                </form>

                                                            </div>
                                                        </b-modal>
                                                        <b-modal ref="mdl-editBestpractice" id="mdl-editBestpractice"
                                                            hide-footer title="Edit Bestpractice">
                                                            <div>
                                                                <form ref="form" @submit.prevent="modifyBestpractice()">
                                                                    <b-row>
                                                                        <b-col class="col-md-4"> Best Practice: </b-col>
                                                                        <b-col class="col-md-8"> <textarea required
                                                                                class="col-md-12" name="bestpractice"
                                                                                id="bestpractice" v-model="bestpractice"
                                                                                @keyup="CountWords(bestpractice, 'bestpracticetotalwords', 'editBestpractice')"
                                                                                rows="10"></textarea> <br /> <span
                                                                                id="bestpracticetotalwords"></span></b-col>
                                                                    </b-row>
                                                                    <b-button id="editBestpractice"
                                                                        type="submit">Save</b-button>
                                                                </form>

                                                            </div>
                                                        </b-modal>
                                                        <b-modal ref="mdl-deleteBestpractice"
                                                            id="mdl-deleteBestpractice" hide-footer
                                                            title="Delete Bestpractice">
                                                            <div>
                                                                <form ref="form" @submit.prevent="delBestpractice()">

                                                                    <br />
                                                                    <b-row>
                                                                        <b-col class="col-md-6"> Are you sure you want
                                                                            to Delete? </b-col>
                                                                    </b-row>
                                                                    <br />
                                                                    <b-row>
                                                                        <b-col class="col-md-2">
                                                                            <b-button id="deleteBestpractice"
                                                                                @click="hidedeleteBestpracticeModal">NO</b-button>
                                                                        </b-col>
                                                                        <b-col class="col-md-5 col-md-offset-1">
                                                                            <b-button id="deleteBestpractice"
                                                                                type="submit">YES</b-button>
                                                                        </b-col>
                                                                    </b-row>
                                                                </form>

                                                            </div>
                                                        </b-modal>
                                                        <!--div class="row">
                                                            <b-col sm="12" class="h-25 mt-3" style="">
                                                                <div v-bind:style="bestpracticesShow"
                                                                    style="font-family:roboto; font-size:18px; word-break: break-word;"
                                                                    v-html="model.best_practices"></div>
                                                                <vue-editor v-bind:style="bestpracticesEdit"
                                                                    id="best_practices" name="best_practices" placeholder=""
                                                                    rows="2" max-rows="8" maxlength="1500" v-bind:disabled="savingInfo"
                                                                    v-model="model.best_practices"></vue-editor>
                                                            </b-col>
                                                        </div>
                                                        <div class="row">
                                                            <b-col sm="10">
                                                            </b-col>
                                                            <b-col sm="2" class="mt-2"
                                                                style="text-align:center; background-color:#96C65A;">
                                                                <div style="float: center;">
                                                                    <b-button @click="editBestpractices = false"
                                                                        v-bind:style="bestpracticesEdit" type="submit"
                                                                        v-bind:disabled="savingInfo" class="" size="md"
                                                                        style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                                        <span v-if="savingInfo"><i
                                                                                class="fa fa-spinner fa-spin"></i> Loading
                                                                            ...</span>
                                                                        <span v-else>{{ saveText }}</span>
                                                                    </b-button>
                                                                    <b-button size="md" @click="editBestpractices = true"
                                                                        v-bind:style="bestpracticesShow"
                                                                        style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                                        <span>Update</span>
                                                                    </b-button>
                                                                </div>
                                                            </b-col>
                                                        </div>
                                                        <b-row>
                                                            <b-col sm="9" class="mt-3">
                                                            </b-col>
                                                            <b-col sm="3" class="mt-3">
                                                                <div style="clear: both; float: right;"><span
                                                                        v-html="processingMessage" /></div>
                                                            </b-col>
                                                        </b-row-->
                                                    </b-tab>
                                                    <b-tab>
                                                        <template v-slot:title>
                                                            <h6 class="mb-0"
                                                                style="font-weight: normal; color:#1D1D1D;">
                                                                Opportunities</h6>
                                                        </template>
                                                        <br />
                                                        <table class="table dataTable table-bordered"
                                                            id="opportunities_table">
                                                            <thead>
                                                                <tr>
                                                                    <th width="85%">Opportunity</th>
                                                                    <th width="15%">Actions</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="item in opportunities_data" :key="item.id">
                                                                    <td>{{ item.opportunity }}</td>
                                                                    <td> <a v-bind:href="'/editopportunity/' + item.id"
                                                                            class="opportunityedit" id="item.id"
                                                                            @click.stop="editOpportunity(item.id)">Edit
                                                                        </a> | <a
                                                                            v-bind:href="'/deleteopportunity/' + item.id"
                                                                            class="opportunitydelete" id="item.id"
                                                                            @click.stop="deleteOpportunity(item.id)">Delete
                                                                        </a></td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                        <br />
                                                        <b-button ref="addOpportunity" id="addOpportunity"
                                                            style="margin-left: 15px;" @click="showOpportunityModal"
                                                            v-show="opportunities_data.length < 1">Add
                                                            Opportunity</b-button>
                                                        <b-modal ref="mdl-addOpportunity" id="mdl-addOpportunity"
                                                            hide-footer title="Add Opportunity">
                                                            <div>
                                                                <form ref="form" @submit.prevent="addOpportunity()">
                                                                    <b-row>
                                                                        <b-col class="col-md-4"> Opportunity: </b-col>
                                                                        <b-col class="col-md-8"> <textarea required
                                                                                class="col-md-12" name="opportunity"
                                                                                id="opportunity" v-model="opportunity"
                                                                                @keyup="CountWords(opportunity, 'opportunitytotalwords', 'addopportunity')"
                                                                                rows="10"></textarea> <br /> <span
                                                                                id="opportunitytotalwords"></span></b-col>
                                                                    </b-row>
                                                                    <b-button id="addopportunity" class=" btn-primary"
                                                                        type="submit">Save</b-button>
                                                                </form>

                                                            </div>
                                                        </b-modal>
                                                        <b-modal ref="mdl-editOpportunity" id="mdl-editOpportunity"
                                                            hide-footer title="Edit Opportunity">
                                                            <div>
                                                                <form ref="form" @submit.prevent="modifyOpportunity()">
                                                                    <b-row>
                                                                        <b-col class="col-md-4"> Opportunity: </b-col>
                                                                        <b-col class="col-md-8"> <textarea required
                                                                                class="col-md-12" name="opportunity"
                                                                                id="opportunity" v-model="opportunity"
                                                                                @keyup="CountWords(opportunity, 'opportunitytotalwords', 'editOpportunity')"
                                                                                rows="10"></textarea> <br /> <span
                                                                                id="opportunitytotalwords"></span></b-col>
                                                                    </b-row>
                                                                    <b-button id="editOpportunity"
                                                                        type="submit">Save</b-button>
                                                                </form>

                                                            </div>
                                                        </b-modal>
                                                        <b-modal ref="mdl-deleteOpportunity" id="mdl-deleteOpportunity"
                                                            hide-footer title="Delete Opportunity">
                                                            <div>
                                                                <form ref="form" @submit.prevent="delOpportunity()">

                                                                    <br />
                                                                    <b-row>
                                                                        <b-col class="col-md-6"> Are you sure you want
                                                                            to Delete? </b-col>
                                                                    </b-row>
                                                                    <br />
                                                                    <b-row>
                                                                        <b-col class="col-md-2">
                                                                            <b-button id="deleteOpportunity"
                                                                                @click="hidedeleteOpportunityModal">NO</b-button>
                                                                        </b-col>
                                                                        <b-col class="col-md-5 col-md-offset-1">
                                                                            <b-button id="deleteOpportunity"
                                                                                type="submit">YES</b-button>
                                                                        </b-col>
                                                                    </b-row>
                                                                </form>

                                                            </div>
                                                        </b-modal>
                                                        <!--div class="row">
                                                            <b-col sm="12" class="h-25 mt-3" style="">
                                                                <div v-bind:style="opportunitiesShow"
                                                                    style="font-family:roboto; font-size:18px; word-break: break-word;"
                                                                    v-html="model.opportunities"></div>
                                                                <vue-editor v-bind:style="opportunitiesEdit"
                                                                    id="opportunities" name="opportunities" placeholder=""
                                                                    rows="2" max-rows="8"  v-bind:disabled="savingInfo"
                                                                    v-model="model.opportunities" @keyup="CountWords2(model.opportunities, 'opportunitiestotalwords')"></vue-editor>  <br/> <span id="opportunitiestotalwords">{{ totalwords }} </span>
                                                            </b-col>
                                                        </div>
                                                        <div class="row">
                                                            <b-col sm="10">
                                                            </b-col>
                                                            <b-col sm="2" class="mt-2"
                                                                style="text-align:center; background-color:#96C65A;">
                                                                <div style="float: center;">
                                                                    <b-button @click="editOpportunities = false"
                                                                        v-bind:style="opportunitiesEdit" type="submit"
                                                                        v-bind:disabled="savingInfo" class="" size="md"
                                                                        style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                                        <span v-if="savingInfo"><i
                                                                                class="fa fa-spinner fa-spin"></i> Loading
                                                                            ...</span>
                                                                        <span v-else>{{ saveText }}</span>
                                                                    </b-button>
                                                                    <b-button size="md" @click="editOpportunities = true"
                                                                        v-bind:style="opportunitiesShow"
                                                                        style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                                        <span>Update</span>
                                                                    </b-button>
                                                                </div>
                                                            </b-col>
                                                        </div>
                                                        <b-row>
                                                            <b-col sm="9" class="mt-3">
                                                            </b-col>
                                                            <b-col sm="3" class="mt-3">
                                                                <div style="clear: both; float: right;"><span
                                                                        v-html="processingMessage" /></div>
                                                            </b-col>
                                                        </b-row-->
                                                    </b-tab>

                                                    <b-tab class="mb-4">
                                                        <template v-slot:title>
                                                            <h6 class="mb-0"
                                                                style="font-weight: normal; color:#1D1D1D;">
                                                                Challenges</h6>
                                                        </template>
                                                        <br />
                                                        <table class="table dataTable table-bordered"
                                                            id="challenges_table">
                                                            <thead>
                                                                <tr>
                                                                    <th width="20%">Challenge Category</th>
                                                                    <th width="60%">Challenge Highlights</th>
                                                                    <th width="20%">Actions</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="item in challenges_data" :key="item.id">
                                                                    <td>{{ item.challenge_category }}</td>
                                                                    <td>{{ item.challenge }}</td>
                                                                    <td> <a v-bind:href="'/editchallenge/' + item.id"
                                                                            class="challengeedit" id="item.id"
                                                                            @click.stop="editChallenge(item.id)">Edit
                                                                        </a> | <a
                                                                            v-bind:href="'/deletechallenge/' + item.id"
                                                                            class="challengedelete" id="item.id"
                                                                            @click.stop="deleteChallenge(item.id)">Delete
                                                                        </a></td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                        <br />
                                                        <b-button ref="addChallenge" id="addChallenge"
                                                            style="margin-left: 15px;" @click="showChallengeModal"
                                                            v-show="challenges_data.length < 4">Add Challenge</b-button>
                                                        <b-modal ref="mdl-addChallenge" id="mdl-addChallenge"
                                                            hide-footer title="Add Challenge">
                                                            <div>
                                                                <form ref="form" @submit.prevent="addChallenge()">
                                                                    <b-row>
                                                                        <b-col class="col-md-4"> Challenge Category
                                                                        </b-col>
                                                                        <b-col class="col-md-8">
                                                                            <select required
                                                                                name="challenge_category_id"
                                                                                id="challenge_category_id"
                                                                                class="col-md-12"
                                                                                v-model="challenge_category_id">
                                                                                <option>---Select Category---</option>
                                                                                <option
                                                                                    v-for="option in challenge_categories">
                                                                                    {{ option }}</option>
                                                                            </select>
                                                                        </b-col>
                                                                    </b-row>
                                                                    <br />
                                                                    <b-row>
                                                                        <b-col class="col-md-4"> Challenge Highlights:
                                                                        </b-col>
                                                                        <b-col class="col-md-8"> <textarea required
                                                                                class="col-md-12" name="challenge"
                                                                                id="challenge" v-model="challenge"
                                                                                @keyup="CountWords(challenge, 'totalwords', 'addchallenge')"
                                                                                rows="10"></textarea> <br /> <span
                                                                                id="totalwords">{{ totalwords }}
                                                                            </span> </b-col>

                                                                    </b-row>
                                                                    <b-button id="addchallenge" class=" btn-primary"
                                                                        type="submit">Save</b-button>
                                                                </form>

                                                            </div>
                                                        </b-modal>
                                                        <b-modal ref="mdl-editChallenge" id="mdl-editChallenge"
                                                            hide-footer title="Edit Challenge">
                                                            <div>
                                                                <form ref="form" @submit.prevent="modifyChallenge()">
                                                                    <b-row>
                                                                        <b-col class="col-md-4"> Challenge Category
                                                                        </b-col>
                                                                        <b-col class="col-md-8">
                                                                            <select required
                                                                                name="challenge_category_id"
                                                                                id="challenge_category_id"
                                                                                class="col-md-12"
                                                                                v-model="challenge_category_id">
                                                                                <option>---Select Category---</option>
                                                                                <option
                                                                                    v-for="option in challenge_categories">
                                                                                    {{ option }}</option>
                                                                            </select>
                                                                        </b-col>
                                                                    </b-row>
                                                                    <br />
                                                                    <b-row>
                                                                        <b-col class="col-md-4"> Challenge Highlights:
                                                                        </b-col>
                                                                        <b-col class="col-md-8"> <textarea required
                                                                                class="col-md-12" name="challenge"
                                                                                id="challenge" v-model="challenge"
                                                                                @keyup="CountWords(challenge, 'totalwords', 'editChallenge')"
                                                                                rows="10"></textarea> <br /> <span
                                                                                id="totalwords">{{ totalwords }}
                                                                            </span> </b-col>

                                                                    </b-row>
                                                                    <b-button id="editChallenge"
                                                                        type="submit">Save</b-button>
                                                                </form>

                                                            </div>
                                                        </b-modal>
                                                        <b-modal ref="mdl-deleteChallenge" id="mdl-deleteChallenge"
                                                            hide-footer title="Delete Challenge">
                                                            <div>
                                                                <form ref="form" @submit.prevent="delChallenge()">

                                                                    <br />
                                                                    <b-row>
                                                                        <b-col class="col-md-6"> Are you sure you want
                                                                            to Delete? </b-col>
                                                                    </b-row>
                                                                    <br />
                                                                    <b-row>
                                                                        <b-col class="col-md-2">
                                                                            <b-button id="deleteChallenge"
                                                                                @click="hidedeleteChallengeModal">NO</b-button>
                                                                        </b-col>
                                                                        <b-col class="col-md-5 col-md-offset-1">
                                                                            <b-button id="deleteChallenge"
                                                                                type="submit">YES</b-button>
                                                                        </b-col>
                                                                    </b-row>
                                                                </form>

                                                            </div>
                                                        </b-modal>
                                                    </b-tab>

                                                    <b-tab class="mb-4">
                                                        <template v-slot:title>
                                                            <h6 class="mb-0"
                                                                style="font-weight: normal; color:#1D1D1D;">
                                                                Risks</h6>
                                                        </template>
                                                        <br />
                                                        <table class="table dataTable table-bordered" id="risks_table">
                                                            <thead>
                                                                <tr>
                                                                    <th width="20%">Risk Category</th>
                                                                    <th width="60%">Risk Highlights</th>
                                                                    <th width="20%">Actions</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="item in risks_data" :key="item.id">
                                                                    <td>{{ item.risk_category }}</td>
                                                                    <td>{{ item.risk }}</td>
                                                                    <td> <a v-bind:href="'/editrisk/' + item.id"
                                                                            class="riskedit" id="item.id"
                                                                            @click.stop="editRisk(item.id)">Edit </a> |
                                                                        <a v-bind:href="'/deleterisk/' + item.id"
                                                                            class="riskdelete" id="item.id"
                                                                            @click.stop="deleteRisk(item.id)">Delete
                                                                        </a></td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                        <br />
                                                        <div v-if="risks_data != null">
                                                            <b-button ref="addRisk" style="margin-left: 15px;"
                                                                @click="showRiskModal"
                                                                v-show="risks_data.length < 4">Add Risk</b-button>
                                                        </div>
                                                        <div v-else>
                                                            <b-button ref="addRisk" style="margin-left: 15px;"
                                                                @click="showRiskModal">Add
                                                                Risk</b-button>
                                                        </div>

                                                        <b-modal ref="mdl-addRisk" id="mdl-addRisk" hide-footer
                                                            title="Add Risk">
                                                            <div>
                                                                <form ref="form" @submit.prevent="addRisk()">
                                                                    <b-row>
                                                                        <b-col class="col-md-4"> Risk Category </b-col>
                                                                        <b-col class="col-md-8">
                                                                            <select required name="risk_category_id"
                                                                                id="risk_category_id" class="col-md-12"
                                                                                v-model="risk_category_id">
                                                                                <option>---Select Category---</option>
                                                                                <option
                                                                                    v-for="option in risk_categories">{{
                                                                                    option }}</option>
                                                                            </select>
                                                                        </b-col>
                                                                    </b-row>
                                                                    <br />
                                                                    <b-row>
                                                                        <b-col class="col-md-4"> Risk Highlights:
                                                                        </b-col>
                                                                        <b-col class="col-md-8"> <textarea required
                                                                                class="col-md-12" name="risk" id="risk"
                                                                                v-model="risk"
                                                                                @keyup="CountWords(risk, 'totalwords', 'addrisk')"
                                                                                rows="10"></textarea> <br /> <span
                                                                                id="totalwords"> </span></b-col>
                                                                    </b-row>
                                                                    <b-button id="addrisk" class=" btn-primary"
                                                                        type="submit">Save</b-button>
                                                                </form>

                                                            </div>
                                                        </b-modal>
                                                        <b-modal ref="mdl-editRisk" id="mdl-editRisk" hide-footer
                                                            title="Edit Risk">
                                                            <div>
                                                                <form ref="form" @submit.prevent="modifyRisk()">
                                                                    <b-row>
                                                                        <b-col class="col-md-4"> Risk Category </b-col>
                                                                        <b-col class="col-md-8">
                                                                            <select required name="risk_category_id"
                                                                                id="risk_category_id" class="col-md-12"
                                                                                v-model="risk_category_id">
                                                                                <option>---Select Category---</option>
                                                                                <option
                                                                                    v-for="option in risk_categories">{{
                                                                                    option }}</option>
                                                                            </select>
                                                                        </b-col>
                                                                    </b-row>
                                                                    <br />
                                                                    <b-row>
                                                                        <b-col class="col-md-4"> Risk Name: </b-col>
                                                                        <b-col class="col-md-8"> <textarea required
                                                                                class="col-md-12" name="risk" id="risk"
                                                                                v-model="risk"
                                                                                @keyup="CountWords(risk, 'totalwords', 'editRisk')"
                                                                                rows="10"></textarea> <br /> <span
                                                                                id="totalwords">{{ totalwords }}
                                                                            </span></b-col>

                                                                    </b-row>


                                                                    <b-button id="editRisk"
                                                                        type="submit">Save</b-button>
                                                                </form>

                                                            </div>
                                                        </b-modal>

                                                        <b-modal ref="mdl-deleteRisk" id="mdl-deleteRisk" hide-footer
                                                            title="Delete Risk">
                                                            <div>
                                                                <form ref="form" @submit.prevent="delRisk()">

                                                                    <br />
                                                                    <b-row>
                                                                        <b-col class="col-md-6"> Are you sure you want
                                                                            to Delete? </b-col>
                                                                    </b-row>
                                                                    <br />
                                                                    <b-row>
                                                                        <b-col class="col-md-2">
                                                                            <b-button id="deleteRisk"
                                                                                @click="hidedeleteRiskModal">NO</b-button>
                                                                        </b-col>
                                                                        <b-col class="col-md-5 col-md-offset-1">
                                                                            <b-button id="deleteRisk"
                                                                                type="submit">YES</b-button>
                                                                        </b-col>
                                                                    </b-row>
                                                                </form>

                                                            </div>
                                                        </b-modal>
                                                    </b-tab>

                                                    <b-tab>
                                                        <template v-slot:title>
                                                            <h6 class="mb-0"
                                                                style="font-weight: normal; color:#1D1D1D;">Key
                                                                Lessons</h6>
                                                        </template>
                                                        <!--div class="row">
                                                            <b-col sm="12" class="h-25 mt-3" style="">
                                                                <div v-bind:style="gapsShow"
                                                                    style="font-family:roboto; font-size:18px; word-break: break-word;"
                                                                    v-html="model.gaps"></div>
                                                                <vue-editor v-bind:style="gapsEdit" id="gaps" name="gaps"
                                                                    placeholder="" rows="2" max-rows="8"
                                                                    v-bind:disabled="savingInfo"
                                                                    v-model="model.gaps"></vue-editor>
                                                            </b-col>
                                                        </div>
                                                        <div class="row">
                                                            <b-col sm="10">
                                                            </b-col>
                                                            <b-col sm="2" class="mt-2"
                                                                style="text-align:center; background-color:#96C65A;">
                                                                <div style="float: center;">
                                                                    <b-button @click="editGaps = false"
                                                                        v-bind:style="gapsEdit" type="submit"
                                                                        v-bind:disabled="savingInfo" class="" size="md"
                                                                        style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                                        <span v-if="savingInfo"><i
                                                                                class="fa fa-spinner fa-spin"></i> Loading
                                                                            ...</span>
                                                                        <span v-else>{{ saveText }}</span>
                                                                    </b-button>
                                                                    <b-button size="md" @click="editGaps = true"
                                                                        v-bind:style="gapsShow"
                                                                        style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                                        <span>Update</span>
                                                                    </b-button>
                                                                </div>
                                                            </b-col>
                                                        </div>
                                                        <b-row>
                                                            <b-col sm="9" class="mt-3">
                                                            </b-col>
                                                            <b-col sm="3" class="mt-3">
                                                                <div style="clear: both; float: right;"><span
                                                                        v-html="processingMessage" /></div>
                                                            </b-col>
                                                        </b-row-->


                                                        <br />
                                                        <table class="table dataTable table-bordered"
                                                            id="keylessons_table">
                                                            <thead>
                                                                <tr>
                                                                    <th width="85%">Key Lesson</th>
                                                                    <th width="15%">Actions</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="item in keylessons_data" :key="item.id">
                                                                    <td>{{ item.keylesson }}</td>
                                                                    <td> <a v-bind:href="'/editkeylesson/' + item.id"
                                                                            class="keylessonedit" id="item.id"
                                                                            @click.stop="editKeylesson(item.id)">Edit
                                                                        </a> | <a
                                                                            v-bind:href="'/deletekeylesson/' + item.id"
                                                                            class="keylessondelete" id="item.id"
                                                                            @click.stop="deleteKeylesson(item.id)">Delete
                                                                        </a></td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                        <br />
                                                        <b-button ref="addKeylesson" id="addKeylesson"
                                                            style="margin-left: 15px;" @click="showKeylessonModal"
                                                            v-show="keylessons_data.length < 1">Add Key
                                                            Lesson</b-button>
                                                        <b-modal ref="mdl-addKeylesson" id="mdl-addKeylesson"
                                                            hide-footer title="Add Key Lesson">
                                                            <div>
                                                                <form ref="form" @submit.prevent="addKeylesson()">
                                                                    <b-row>
                                                                        <b-col class="col-md-4"> Key Lesson: </b-col>
                                                                        <b-col class="col-md-8"> <textarea required
                                                                                class="col-md-12" name="keylesson"
                                                                                id="keylesson" v-model="keylesson"
                                                                                @keyup="CountWords(keylesson, 'keylessontotalwords', 'addkeylesson')"
                                                                                rows="10"></textarea> <br /> <span
                                                                                id="keylessontotalwords"></span></b-col>
                                                                    </b-row>
                                                                    <b-button id="addkeylesson" class=" btn-primary"
                                                                        type="submit">Save</b-button>
                                                                </form>

                                                            </div>
                                                        </b-modal>
                                                        <b-modal ref="mdl-editKeylesson" id="mdl-editKeylesson"
                                                            hide-footer title="Edit Keylesson">
                                                            <div>
                                                                <form ref="form" @submit.prevent="modifyKeylesson()">
                                                                    <b-row>
                                                                        <b-col class="col-md-4"> Key Lesson: </b-col>
                                                                        <b-col class="col-md-8"> <textarea required
                                                                                class="col-md-12" name="keylesson"
                                                                                id="keylesson" v-model="keylesson"
                                                                                @keyup="CountWords(keylesson, 'keylessontotalwords', 'editKeylesson')"
                                                                                rows="10"></textarea> <br /> <span
                                                                                id="keylessontotalwords"></span></b-col>
                                                                    </b-row>
                                                                    <b-button id="editKeylesson"
                                                                        type="submit">Save</b-button>
                                                                </form>

                                                            </div>
                                                        </b-modal>
                                                        <b-modal ref="mdl-deleteKeylesson" id="mdl-deleteKeylesson"
                                                            hide-footer title="Delete Keylesson">
                                                            <div>
                                                                <form ref="form" @submit.prevent="delKeylesson()">

                                                                    <br />
                                                                    <b-row>
                                                                        <b-col class="col-md-6"> Are you sure you want
                                                                            to Delete? </b-col>
                                                                    </b-row>
                                                                    <br />
                                                                    <b-row>
                                                                        <b-col class="col-md-2">
                                                                            <b-button id="deleteKeylesson"
                                                                                @click="hidedeleteKeylessonModal">NO</b-button>
                                                                        </b-col>
                                                                        <b-col class="col-md-5 col-md-offset-1">
                                                                            <b-button id="deleteKeylesson"
                                                                                type="submit">YES</b-button>
                                                                        </b-col>
                                                                    </b-row>
                                                                </form>

                                                            </div>
                                                        </b-modal>
                                                    </b-tab>
                                                </b-tabs>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card-text>
                            </b-tab>
                            <b-tab class="mb-4">
                                <template v-slot:title>
                                    <h6 class="mb-2 mt-3"
                                        style="font-weight: 600; font-size:17px; font-family:roboto; color:#1D1D1D;">
                                        PARTNERS</h6>
                                </template>
                                <b-container>
                                    <b-card-text>
                                        <b-row>
                                            <b-col sm="12">
                                                <h5 style="font-weight: 600; font-family:Roboto; color:#202020;">
                                                    Partners
                                                </h5>
                                            </b-col>
                                        </b-row>
                                    </b-card-text>
                                    <b-card-text>
                                        <b-col style="margin-left:10px;">
                                            <div class="row">
                                                <b-col sm="3" class="h-25 mt-3" style="">
                                                    <span v-bind:style="partnersEdit"
                                                        class="badge badge-info mt-1">Patner Category</span>
                                                </b-col>
                                                <b-col sm="9" class="h-25 mt-3" style="">
                                                    <b-form-select v-model="model.partner_id" text="Patner Catagories"
                                                        id="partner_id" name="partner_id" v-bind:disabled="savingInfo"
                                                        v-bind:style="partnersEdit" :options="partnersCategoryOptions">
                                                    </b-form-select>
                                                </b-col>
                                            </div>
                                            <br />
                                            <b-row>
                                                <table class="table dataTable table-bordered" id="partners_table">
                                                    <thead>
                                                        <tr>
                                                            <th>Partner Category</th>
                                                            <th>Partner</th>
                                                            <th>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="item in partners_data" :key="item.id">
                                                            <td>{{ item.partner_category }}</td>
                                                            <td>{{ item.partner }}</td>
                                                            <td> <a v-bind:href="'/editpartner/' + item.id"
                                                                    class="partneredit" id="item.id"
                                                                    @click.stop="editPartner(item.id)">Edit </a> | <a
                                                                    v-bind:href="'/deletepartner/' + item.id"
                                                                    class="partnerdelete" id="item.id"
                                                                    @click.stop="deletePartner(item.id)">Delete </a>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </b-row>
                                            <br />
                                            <b-row>
                                                <b-button id="show-btn" style="margin-left: 15px;"
                                                    @click="showModal">Add Partner</b-button>
                                                <b-modal ref="mdl-addPartner" id="mdl-addPartner" hide-footer
                                                    title="Add Partner">
                                                    <div>
                                                        <form ref="form" @submit.prevent="addPartner()">
                                                            <b-row>
                                                                <b-col class="col-md-4"> Patner Category </b-col>
                                                                <b-col class="col-md-8">
                                                                    <select required name=" " id="partner_category_id"
                                                                        v-model="partner_category_id">
                                                                        <option>---Select Category---</option>
                                                                        <option v-for="option in partner_categories">{{
                                                                            option }}</option>
                                                                    </select>
                                                                </b-col>
                                                            </b-row>
                                                            <br />
                                                            <b-row>
                                                                <b-col class="col-md-4"> Partner Name: </b-col>
                                                                <b-col class="col-md-8"> <input type="text" required
                                                                        class="col-md-12" name="partner" id="partner"
                                                                        v-model="partner"></b-col>

                                                            </b-row>
                                                            <b-button id="addpartner" class=" btn-primary"
                                                                type="submit">Save</b-button>
                                                        </form>

                                                    </div>
                                                </b-modal>
                                                <b-modal ref="mdl-editPartner" id="mdl-editPartner" hide-footer
                                                    title="Edit Partner">
                                                    <div>
                                                        <form ref="form" @submit.prevent="modifyPartner()">
                                                            <b-row>
                                                                <b-col class="col-md-4"> Patner Category </b-col>
                                                                <b-col class="col-md-8">
                                                                    <select required name=" " id="partner_category_id"
                                                                        v-model="partner_category_id">
                                                                        <option>---Select Category---</option>
                                                                        <option v-for="option in partner_categories">{{
                                                                            option }}</option>
                                                                    </select>
                                                                </b-col>
                                                            </b-row>
                                                            <br />
                                                            <b-row>
                                                                <b-col class="col-md-4"> Partner Name: </b-col>
                                                                <b-col class="col-md-8"> <input type="text" required
                                                                        class="col-md-12" name="partner" id="partner"
                                                                        v-model="partner"></b-col>

                                                            </b-row>


                                                            <b-button id="editPartner" type="submit">Save</b-button>
                                                        </form>

                                                    </div>
                                                </b-modal>

                                                <b-modal ref="mdl-deletePartner" id="mdl-delPartner" hide-footer
                                                    title="Delete Partner">
                                                    <div>
                                                        <form ref="form" @submit.prevent="delPartner()">

                                                            <br />
                                                            <b-row>
                                                                <b-col class="col-md-6"> Are you sure you want to
                                                                    Delete? </b-col>
                                                            </b-row>
                                                            <br />
                                                            <b-row>
                                                                <b-col class="col-md-2">
                                                                    <b-button id="delPartner"
                                                                        @click="hidedeletePartnerModal">NO</b-button>
                                                                </b-col>
                                                                <b-col class="col-md-5 col-md-offset-1">
                                                                    <b-button id="delPartner"
                                                                        type="submit">YES</b-button>
                                                                </b-col>
                                                            </b-row>
                                                        </form>

                                                    </div>
                                                </b-modal>
                                                <!--b-col class="h-25">
                                                <div v-bind:style="partnersShow"
                                                    style="font-family:roboto; font-size:18px; word-break: break-word;"
                                                    v-html="model.partners"></div>
                                                 
                                                <vue-editor v-bind:style="partnersEdit" id="partners" name="partners"
                                                    placeholder="" :maxlength="max" rows="2" max-rows="8"
                                                    v-bind:disabled="savingInfo" v-model="model.partners" />
                                            </b-col-->
                                            </b-row>

                                        </b-col>
                                    </b-card-text>
                                </b-container>

                                <b-card-text>
                                    <b-col>
                                        <b-row>
                                            <b-col sm="9" class="mt-3">
                                            </b-col>
                                            <b-col sm="3" class="mt-3">
                                                <div style="clear: both; float: right;"><span
                                                        v-html="processingMessage" />
                                                </div>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card-text>
                            </b-tab>
                            <b-tab class="mb-4">
                                <template v-slot:title>
                                    <h6 class="mb-2 mt-3"
                                        style="font-weight: 600; font-size:17px; font-family:roboto; color:#1D1D1D;">
                                        LINK
                                        TO POW</h6>
                                </template>
                                <b-card-text>
                                    <b-col>
                                        <b-row>
                                            <b-col>
                                                <h5 class="mheader"
                                                    style="font-weight: 600; font-family:Roboto; color:#202020;">Link to
                                                    Programme of Work</h5>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col>
                                                <ul>
                                                    <li v-if="modelData['pow_outcome'].length == 0"><span
                                                            style="font-family:roboto; font-size:18px;">NO PoWs</span>
                                                    </li>
                                                    <li v-for="item in modelData['pow_outcome']" :key="item.id"
                                                        style="font-family:roboto; font-size:18px;">
                                                        {{ item.pow }}
                                                    </li>
                                                </ul>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card-text>
                            </b-tab>
                            <b-tab class="mb-4">
                                <template v-slot:title>
                                    <h6 class="mb-2 mt-3"
                                        style="font-weight: 600; font-size:17px; font-family:roboto; color:#1D1D1D;">
                                        LINK TO PROJECTS</h6>
                                </template>
                                <b-card-text>
                                    <b-col>
                                        <b-row>
                                            <b-col sm="12">
                                                <h5 class="mheader"
                                                    style="font-weight: 600; font-family:Roboto; color:#202020;">Link to
                                                    Projects
                                                </h5>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card-text>
                                <b-card-text style="max-width: 730px;">
                                    <table class="table dataTable table-bordered" id="projects_table">
                                        <thead>
                                            <tr>
                                                <th width="15%">Project ID</th>
                                                <th width="65%">Project Name</th>
                                                <th width="20%">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in projects_data" :key="item.id">
                                                <td>{{ item.project_id }}</td>
                                                <td>{{ item.project_name }}</td>
                                                <td><a v-bind:href="'/editproject/' + item.id" class="projectedit"
                                                        id="item.id" @click.stop="editProject(item.id)">Edit </a> | <a
                                                        v-bind:href="'/deleteproject/' + item.id" class="projectdelete"
                                                        id="item.id" @click.stop="deleteProject(item.id)">Delete </a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <br />
                                    <div v-if="projects_data == null">
                                        <b-button ref="addProject" style="margin-left: 15px;"
                                            @click="showProjectModal">Add Project</b-button>
                                    </div>
                                    <div v-else="">
                                        <b-button ref="addProject" style="margin-left: 15px;"
                                            @click="showProjectModal">Add Project</b-button>
                                    </div>

                                    <b-modal ref="mdl-addProject" id="mdl-addProject" hide-footer title="Add Project">
                                        <div>
                                            <form ref="form" @submit.prevent="addProject()">
                                                <b-row>
                                                    <b-col class="col-md-3"> Project ID: </b-col>
                                                    <b-col class="col-md-5"> <input type="text" required
                                                            class="col-md-12" name="proj_id" id="proj_id"
                                                            v-model="proj_id">
                                                    </b-col>
                                                </b-row>
                                                <br />
                                                <b-row>
                                                    <b-col class="col-md-3"> Project Name: </b-col>
                                                    <b-col class="col-md-8"> <input type="text" required
                                                            class="col-md-12" name="project_name" id="project_name"
                                                            v-model="project_name"></b-col>
                                                </b-row>
                                                <b-button id="addproject" class=" btn-primary"
                                                    type="submit">Save</b-button>
                                            </form>

                                        </div>
                                    </b-modal>
                                    <b-modal ref="mdl-editProject" id="mdl-editProject" hide-footer
                                        title="Edit Project">
                                        <div>
                                            <form ref="form" @submit.prevent="modifyProject()">
                                                <b-row>
                                                    <b-col class="col-md-3"> Project ID: </b-col>
                                                    <b-col class="col-md-5"> <input type="text" required
                                                            class="col-md-12" name="proj_id" id="proj_id"
                                                            v-model="proj_id">
                                                    </b-col>
                                                </b-row>
                                                <br />
                                                <b-row>
                                                    <b-col class="col-md-3"> Project Name: </b-col>
                                                    <b-col class="col-md-8"> <input type="text" required
                                                            class="col-md-12" name="project_name" id="project_name"
                                                            v-model="project_name"></b-col>
                                                </b-row>
                                                <b-button id="editProject" class=" btn-primary"
                                                    type="submit">Save</b-button>
                                            </form>

                                        </div>
                                    </b-modal>
                                    <b-modal ref="mdl-deleteProject" id="mdl-deleteProject" hide-footer
                                        title="Delete Project">
                                        <div>
                                            <form ref="form" @submit.prevent="delProject()">

                                                <br />
                                                <b-row>
                                                    <b-col class="col-md-6"> Are you sure you want to Delete? </b-col>
                                                </b-row>
                                                <br />
                                                <b-row>
                                                    <b-col class="col-md-2">
                                                        <b-button id="deleteProject"
                                                            @click="hidedeleteProjectModal">NO</b-button>
                                                    </b-col>
                                                    <b-col class="col-md-5 col-md-offset-1">
                                                        <b-button id="deleteProject" type="submit">YES</b-button>
                                                    </b-col>
                                                </b-row>
                                            </form>

                                        </div>
                                    </b-modal>
                                    <!--b-col>
                                        <b-row>
                                            <b-col sm="12">
                                                <ul>
                                                    <li v-for="item in model['project_ids']" :key="item.id"
                                                        style="font-family:roboto; font-size:18px;">
                                                        {{ item.text }}
                                                    </li>
                                                </ul>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col sm="11" v-bind:style="projectEdit">
                                                <multiselect class="mymultiselect" v-bind:disabled="savingInfo"
                                                    v-model="model.project_ids" id="project_ids"
                                                    style="word-break: break-all;" :options="projectOptions"
                                                    :multiple="true" :searchable="true" :loading="isLoadingProjects"
                                                    :internal-search="false" :clear-on-select="false"
                                                    :close-on-select="false" :options-limit="300" :limit="15"
                                                    :limit-text="limitTextProjects" :max-height="600"
                                                    :show-no-results="false"
                                                    :class="(model.project_ids.length == 0 ? 'emptySelect' : '')"
                                                    :hide-selected="true" @search-change="asyncFindProjects"
                                                    placeholder="Type to search projects" track-by="value" label="text">
                                                    <span slot="noResult">No projects found. Your search query is empty or
                                                        returned no results.</span>
                                                </multiselect>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card-text>
                                <b-card-text>
                                    <b-col sm="12">
                                        <b-row>
                                            <b-col sm="10">
                                            </b-col>
                                            <b-col sm="2" class="mt-2" style="text-align:center; background-color:#96C65A;">
                                                <div style="float: center;">
                                                    <b-button @click="editproject = false" v-bind:style="projectEdit"
                                                        type="submit" v-bind:disabled="savingInfo" class="" size="md"
                                                        style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                        <span v-if="savingInfo"><i class="fa fa-spinner fa-spin"></i>
                                                            Loading ...</span>
                                                        <span v-else>{{ saveText }}</span>
                                                    </b-button>
                                                    <b-button size="md" @click="editproject = true"
                                                        v-bind:style="projectShow"
                                                        style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                        <span>Update</span>
                                                    </b-button>
                                                </div>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col sm="9" class="mt-3">
                                            </b-col>
                                            <b-col sm="3" class="mt-3">
                                                <div style="clear: both; float: right;"><span v-html="processingMessage" />
                                                </div>
                                            </b-col>
                                        </b-row>
                                    </b-col-->
                                </b-card-text>
                            </b-tab>
                            <b-tab class="mb-4">
                                <template v-slot:title>
                                    <h6 class="mb-2 mt-3"
                                        style="font-weight: 600; font-size:17px; font-family:roboto; color:#1D1D1D;">
                                        CONTRIBUTION TO MEAs</h6>
                                </template>
                                <b-card-text>
                                    <b-col>
                                        <b-row>
                                            <b-col>
                                                <h5 style="font-weight: 600; font-family:Roboto; color:#202020;">MEAs
                                                </h5>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card-text>
                                <b-card-text>
                                    <b-col>
                                        <table class="table dataTable table-bordered" id="meas_table">
                                            <thead>
                                                <tr>
                                                    <th width="85%">MEAs</th>
                                                    <th width="15%">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="item in meas_data" :key="item.id">
                                                    <td>{{ item.text }}</td>
                                                    <td><a v-bind:href="'/deletemea/' + item.id" class="meadelete"
                                                            id="item.id" @click.stop="deleteMea(item.id)">Delete </a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <br />
                                        <div v-if="meas_data == null">
                                            <b-button ref="addMea" style="margin-left: 15px;" @click="showMeaModal">Add
                                                MEA</b-button>
                                        </div>
                                        <div v-else="">
                                            <b-button ref="addMea" style="margin-left: 15px;" @click="showMeaModal">Add
                                                MEA</b-button>
                                        </div>

                                        <b-modal ref="mdl-addMea" id="mdl-addMea" hide-footer title="Add/Edit Meas"
                                            class="col-md-10">
                                            <div>
                                                <form ref="form" @submit.prevent="addMea()">
                                                    <b-row>
                                                        <b-col class="col-md-1"> MEA </b-col>
                                                        <b-col class="col-md-11">
                                                            <select v-model="meas_ids" id="meas_ids" name="meas_ids"
                                                                multiple class="col-md-12" size="15">
                                                                <option v-for="option in measOptions"
                                                                    v-bind:value="option.value">
                                                                    {{ option.text }}
                                                                </option>
                                                            </select><!--v-bind:selected="{{meas_data.id.contains(option.value)}}" :selected="meas_data"  -->
                                                            <!--multiselect class="mymultiselect" v-bind:disabled="savingInfo"
                                                                    v-model="meas_ids" id="meas_ids" :options="measOptions"
                                                                    :multiple="true" :searchable="true" :loading="isLoadingMeas"
                                                                    :internal-search="false" :clear-on-select="false"
                                                                    :close-on-select="false" :options-limit="300" :limit="15"
                                                                    :limit-text="limitTextMeas" :max-height="600" :show-no-results="false"
                                                                    :class="(meas_data.length == 0 ? 'emptySelect' : '')"
                                                                    :hide-selected="true"  
                                                                    placeholder="Type to search Meas" track-by="value" label="text">
                                                                    <span slot="noResult">No Meas found. Your search query is empty or
                                                                        returned no results.</span>
                                                                </multiselect>
                                                            </select-->
                                                        </b-col>
                                                    </b-row>
                                                    <br />
                                                    <b-button id="addmea" class=" btn-primary"
                                                        type="submit">Save</b-button>
                                                </form>

                                            </div>
                                        </b-modal>
                                        <b-modal ref="mdl-deleteMea" id="mdl-deleteMea" hide-footer title="Delete MEA">
                                            <div>
                                                <form ref="form" @submit.prevent="delMea()">

                                                    <br />
                                                    <b-row>
                                                        <b-col class="col-md-6"> Are you sure you want to Delete?
                                                        </b-col>
                                                    </b-row>
                                                    <br />
                                                    <b-row>
                                                        <b-col class="col-md-2">
                                                            <b-button id="deleteMea"
                                                                @click="hidedeleteMeaModal">NO</b-button>
                                                        </b-col>
                                                        <b-col class="col-md-5 col-md-offset-1">
                                                            <b-button id="deleteMea" type="submit">YES</b-button>
                                                        </b-col>
                                                    </b-row>
                                                </form>

                                            </div>
                                        </b-modal>





                                        <!--b-row>
                                            <b-col sm="12">
                                                <ul>
                                                    <li v-for="item in model['meas_ids']" :key="item.id"
                                                        style="font-family:roboto; font-size:18px;">
                                                        {{ item.text }}
                                                    </li>
                                                </ul>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col sm="10" v-bind:style="measEdit">
                                                <multiselect class="mymultiselect" v-bind:disabled="savingInfo"
                                                    v-model="model.meas_ids" id="meas_ids" :options="measOptions"
                                                    :multiple="true" :searchable="true" :loading="isLoadingMeas"
                                                    :internal-search="false" :clear-on-select="false"
                                                    :close-on-select="false" :options-limit="300" :limit="15"
                                                    :limit-text="limitTextMeas" :max-height="600" :show-no-results="false"
                                                    :class="(model.meas_ids.length == 0 ? 'emptySelect' : '')"
                                                    :hide-selected="true" @search-change="asyncFindMeas"
                                                    placeholder="Type to search Meas" track-by="value" label="text">
                                                    <span slot="noResult">No Meas found. Your search query is empty or
                                                        returned no results.</span>
                                                </multiselect>
                                            </b-col>
                                        </b-row-->
                                    </b-col>
                                </b-card-text>
                                <!--b-card-text>
                                    <b-col>
                                        <b-row>
                                            <b-col sm="10">
                                            </b-col>
                                            <b-col sm="2" class="mt-2" style="text-align:center; background-color:#96C65A;">
                                                <div style="float: center;">
                                                    <b-button @click="editMeas = false" v-bind:style="measEdit"
                                                        type="submit" v-bind:disabled="savingInfo" class="" size="md"
                                                        style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                        <span v-if="savingInfo"><i class="fa fa-spinner fa-spin"></i>
                                                            Loading ...</span>
                                                        <span v-else>{{ saveText }}</span>
                                                    </b-button>
                                                    <b-button size="md" @click="editMeas = true" v-bind:style="measShow"
                                                        style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                        <span>Update</span>
                                                    </b-button>
                                                </div>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col sm="9" class="mt-3">
                                            </b-col>
                                            <b-col sm="3" class="mt-3">
                                                <div style="clear: both; float: right;"><span v-html="processingMessage" />
                                                </div>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card-text-->
                            </b-tab>

                            <b-tab class="mb-4">
                                <template v-slot:title>
                                    <h6 class="mb-2 mt-3"
                                        style="font-weight: 600; font-size:17px; font-family:roboto; color:#1D1D1D;">
                                        CONTRIBUTION TO SDGs</h6>
                                </template>
                                <b-card-text>
                                    <b-col>
                                        <b-row>
                                            <b-col>
                                                <h5 style="font-weight: 600; font-family:Roboto; color:#202020;">SDGs
                                                </h5>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card-text>
                                <b-card-text>
                                    <b-col>
                                        <b-row>
                                            <b-col>
                                                <ul>
                                                    <li v-if="modelData['sdg_outcome'].length == 0"><span
                                                            style="font-family:roboto; font-size:18px;">NO SDGs</span>
                                                    </li>
                                                    <li v-for="item in modelData['sdg_outcome']" :key="item.id"
                                                        style="font-family:roboto; font-size:18px;">
                                                        {{ item.sdg }}
                                                    </li>
                                                </ul>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col sm="10" v-bind:style="measEdit">
                                                <multiselect class="mymultiselect" v-bind:disabled="savingInfo"
                                                    v-model="model.sdg_outcome" id="sdg_outcome" :options="sdgsOptions"
                                                    :multiple="true" :searchable="true" :loading="isLoadingSdgs"
                                                    :internal-search="false" :clear-on-select="false"
                                                    :close-on-select="false" :options-limit="300" :limit="15"
                                                    :limit-text="limitTextMeas" :max-height="600"
                                                    :show-no-results="false"
                                                    :class="(model.sdg_outcome.length == 0 ? 'emptySelect' : '')"
                                                    :hide-selected="true" @search-change="asyncFindSdgs"
                                                    placeholder="Type to search SDGs" track-by="value" label="text">
                                                    <span slot="noResult">No SDGs found. Your search query is empty or
                                                        returned no results.</span>
                                                </multiselect>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card-text>
                                <b-card-text>
                                    <b-col>
                                        <b-row>
                                            <b-col sm="10">
                                            </b-col>
                                            <b-col sm="2" class="mt-2"
                                                style="text-align:center; background-color:#96C65A;">
                                                <div style="float: center;">
                                                    <b-button @click="editMeas = false" v-bind:style="measEdit"
                                                        type="submit" v-bind:disabled="savingInfo" class="" size="md"
                                                        style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                        <span v-if="savingInfo"><i class="fa fa-spinner fa-spin"></i>
                                                            Loading ...</span>
                                                        <span v-else>{{ saveText }}</span>
                                                    </b-button>
                                                    <!--b-button size="md" @click="editMeas = true" v-bind:style="measShow"
                                                        style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                        <span>Update</span>
                                                    </b-button-->
                                                </div>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col sm="9" class="mt-3">
                                            </b-col>
                                            <b-col sm="3" class="mt-3">
                                                <div style="clear: both; float: right;"><span
                                                        v-html="processingMessage" />
                                                </div>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card-text>
                            </b-tab>
                            <b-tab class="mb-4">
                                <template v-slot:title>
                                    <h6 class="mb-2 mt-3"
                                        style="font-weight: 600; font-size:17px; font-family:roboto; color:#1D1D1D;">
                                        NEXT
                                        STEPS</h6>
                                </template>
                                <b-card-text>
                                    <b-col>
                                        <b-row>
                                            <b-col sm="12">
                                                <h5 style="font-weight: 600; font-family:Roboto; color:#202020;">Next
                                                    Steps
                                                </h5>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card-text>
                                <b-card-text>
                                    <br />
                                    <table class="table dataTable table-bordered" id="nextsteps_table">
                                        <thead>
                                            <tr>
                                                <th width="85%">Next Step</th>
                                                <th width="15%">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in nextsteps_data" :key="item.id">
                                                <td>{{ item.nextstep }}</td>
                                                <td> <a v-bind:href="'/editnextstep/' + item.id" class="nextstepedit"
                                                        id="item.id" @click.stop="editNextstep(item.id)">Edit </a> | <a
                                                        v-bind:href="'/deletenextstep/' + item.id"
                                                        class="nextstepdelete" id="item.id"
                                                        @click.stop="deleteNextstep(item.id)">Delete </a></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <br />
                                    <b-button ref="addNextstep" id="addNextstep" style="margin-left: 15px;"
                                        @click="showNextstepModal" v-show="nextsteps_data.length < 1">Add Next
                                        Step</b-button>
                                    <b-modal ref="mdl-addNextstep" id="mdl-addNextstep" hide-footer
                                        title="Add Next Step">
                                        <div>
                                            <form ref="form" @submit.prevent="addNextstep()">
                                                <b-row>
                                                    <b-col class="col-md-4"> Next Step: </b-col>
                                                    <b-col class="col-md-8"> <textarea required class="col-md-12"
                                                            name="nextstep" id="nextstep" v-model="nextstep"
                                                            @keyup="CountWords(nextstep, 'nextsteptotalwords', 'addnextstep')"
                                                            rows="10"></textarea> <br /> <span
                                                            id="nextsteptotalwords"></span></b-col>
                                                </b-row>
                                                <b-button id="addnextstep" class=" btn-primary"
                                                    type="submit">Save</b-button>
                                            </form>

                                        </div>
                                    </b-modal>
                                    <b-modal ref="mdl-editNextstep" id="mdl-editNextstep" hide-footer
                                        title="Edit Nextstep">
                                        <div>
                                            <form ref="form" @submit.prevent="modifyNextstep()">
                                                <b-row>
                                                    <b-col class="col-md-4"> Next Step: </b-col>
                                                    <b-col class="col-md-8"> <textarea required class="col-md-12"
                                                            name="nextstep" id="nextstep" v-model="nextstep"
                                                            @keyup="CountWords(nextstep, 'nextsteptotalwords'), 'editNextstep'"
                                                            rows="10"></textarea> <br /> <span
                                                            id="nextsteptotalwords"></span></b-col>
                                                </b-row>
                                                <b-button id="editNextstep" type="submit">Save</b-button>
                                            </form>

                                        </div>
                                    </b-modal>
                                    <b-modal ref="mdl-deleteNextstep" id="mdl-deleteNextstep" hide-footer
                                        title="Delete Nextstep">
                                        <div>
                                            <form ref="form" @submit.prevent="delNextstep()">

                                                <br />
                                                <b-row>
                                                    <b-col class="col-md-6"> Are you sure you want to Delete? </b-col>
                                                </b-row>
                                                <br />
                                                <b-row>
                                                    <b-col class="col-md-2">
                                                        <b-button id="deleteNextstep"
                                                            @click="hidedeleteNextstepModal">NO</b-button>
                                                    </b-col>
                                                    <b-col class="col-md-5 col-md-offset-1">
                                                        <b-button id="deleteNextstep" type="submit">YES</b-button>
                                                    </b-col>
                                                </b-row>
                                            </form>

                                        </div>
                                    </b-modal>
                                </b-card-text>
                            </b-tab>
                            <b-tab>
                                <template v-slot:title>
                                    <h6 class="mt-3"
                                        style="font-weight: 600; font-size:17px; font-family:roboto; color:#9BC455;">
                                        CONFIRM
                                        YOUR SUBMISSION</h6>
                                </template>
                                <b-card-text style="" class="mt-4">
                                    <b-col sm="12">
                                        <b-row>
                                            <b-col sm="12">
                                                <ol style="font-size:17px;">
                                                    <li>Please confirm that you have saved all of your information.</li>
                                                    <li>Confirm that you have filled all the fields information
                                                        correctly.
                                                    </li>
                                                    <li>Confirm that you have spoken with your supervisor on the
                                                        information
                                                        you have submitted.</li>
                                                </ol>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col sm="10">
                                            </b-col>
                                            <b-col sm="2" style="text-align:center;">
                                                <label for="agree">
                                                    <!--<input id="agree" type="checkbox" value="1" v-model="model.submitted"/> I Confirm-->
                                                    <b-form-checkbox id="agree" v-model="model.submitted"
                                                        @change="enableSubmit($event)" name="checkbox-1" value="2"
                                                        unchecked-value="1">
                                                        I Confirm
                                                    </b-form-checkbox>
                                                </label>

                                            </b-col>
                                        </b-row>
                                        <b-row class="mt-3">
                                            <b-col sm="10">
                                            </b-col>
                                            <b-col sm="2" style="text-align:center; background-color:#96C65A;">
                                                <b-button v-bind:disabled="model.submitted == 1" id="submittedButton"
                                                    name="submittedButton" type="submit" size="md"
                                                    @click="submitReports"
                                                    style="background-color:#96C65A; border-radius: unset; border: none; outline:none;">
                                                    <span v-if="savingInfo"><i class="fa fa-spinner fa-spin"></i>
                                                        Loading
                                                        ...</span>
                                                    <span v-else>Submit</span>
                                                </b-button>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card-text>
                            </b-tab>
                        </b-container>
                    </b-row>
                </b-form>
            </b-tabs>

        </div>

        <b-modal id="modalSubmitted" hide-footer>
            <template v-slot:modal-title>Confirmation</template>
            <div>
                <h3>Data submitted successfully</h3>
            </div>
            <b-button class="btn btn-primary" block @click="$bvModal.hide('modalSubmitted')">Close</b-button>
        </b-modal>

    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import Select2 from 'v-select2-component';
import axios from "axios";
import $ from "jquery";
export default {
    components: {
        Multiselect
    },
    name: 'SecretariatReporting',
    data() {
        return {
            input: {
                name: ''
            },
            wordCount: 0,
            totalwords: '',
            implementationplan: '',
            milestone_status_id: '',
            milestone_text: '',
            result_category_id: '',
            result_text: '',
            resource_category_id1: '',
            resource_category_id2: '',
            resource1: '',
            resource2: '',
            bestpractice: '',
            opportunity: '',
            challenge_category_id: '',
            challenge: '',
            risk_category_id: '',
            risk: '',
            keylesson: '',
            partner: '',
            partner_category_id: '',
            project_id: '',
            proj_id: '',
            project_name: '',
            projects_id: '',
            projects_ids: '',
            meas_ids: '',
            nextstep: '',
            boxTwo: '',
            id: '',
            max: 10,
            submitted: 0,
            tabIndex: 1,
            apiUrl: process.env.VUE_APP_API_PATH,
            processingMessage: '',
            submittingMessage: '',
            savingInfo: false,
            submittingInfo: false,
            milestonesOptions: [],
            meaOptions: [],
            modelData: [],
            divisions: [],
            measState: null,
            projectsOptions: [], 
            measOptions: [],  
            implementationplans_data: [],
            milestones_data: [],
            results_data: [],
            resources_data: [],
            bestpractices_data: [],
            opportunities_data: [], 
            challenges_data: [],
            risks_data: [],
            keylessons_data: [],
            partners_data: [],
            projects_data: [],  
            meas_data: [],
            nextsteps_data: [],
            partner_id: null,
            challenge_id: null,
            risk_id: null,
            resultCategoryOptions: [],
            riskCategoryOptions: [],
            projectState: null,
            projectOptions: [],
            isLoadingProjects: false,
            isLoadingMeas: false,
            isLoadingSdgs: false,
            //editResult: false,
            challengedit: false,
            riskedit: false,
            editResources: false,
            editLearning: false,
            editBestpractices: false,
            editOpportunities: false,
            editChallenges: false,
            editGaps: false,
            editRisks: false,
            //editMilestone: false,
            editImplementation: false,
            editMeas: false,
            //editproject: false,
            editPartners: false,
            editNextsteps: false,
            model: {
                id: '',
                period_id: '',
                implementation_plan: '',
                milestone_id: '',
                milestone_description: '',
                result_id: '',
                result_description: '',
                results: '',
                mea_id: '',
                meas: '',
                resources: '',
                challenge_id: '',
                challenges: '',
                risks: '',
                risk_id: '',
                partners: '',
                best_practices: '',
                opportunities: '',
                gaps: '',
                next_steps: '',
                projects_ids: [],
                meas_ids: [],
                sdg_outcome: [],
                result_ids: [],
                inputs: [{
                    name: '',
                    party: ''
                }],
                result_inputs: [{
                    name: '',
                    party: ''
                }],
                submitted: '0',
            },
            partner_categories : [
                "Foundation (Corporate Philanthropic)" ,
                "Foundation (Other)" ,
                "Government" ,
                "Inter-Governmental Organization", 
                "International Non Profit Association", 
                "International Organization", 
                "Not for Profit", 
                "Private Sector ", 
                "Private University", 
                "Public University", 
                "Trust", 
                "UN Agency", 
                "University (Not for profit)",  

            ], 
            challenge_categories : [
                "Delayed or Insufficient Funding",
                "Collaboration with Implementing Partners",
                "Resolutions design issues",
                "Engagement of Recipient country/ organization/ institution",
                "Stability of countries involved",
                "Data availability / sharing",
                "Operational Issues",
                "Other "
            ],
			risk_categories : [
                 "Strategic Risks",
                "Operational Risks/ Implementation Risks",
                "Scope Risks",
                "Scheduling Risks",
                "Resource Risks",
                "Other "
            ],
			result_categories : [
                "Capacity Development / Technical Assistance",
                "Data Collection and Analysis",
                "Direct support / Service Delivery",
                "Innovative Approaches",
                "Institutional Mechanism and System Building",
                "Normative Support",
                "Optimising Financing",
                "Policy Advice",
                "Risk Analysis",
                "Support Functions",
                "Thought Leadership",
                "UN Agency Integration",
                "Other" 
            ],
            model2: {
            milestone_id2: '',
            resources2: '',
        }
        }
    },
    watch: {
    'input.name': function(newVal, oldVal) {
      this.wordCount = newVal.split(' ').length;
      if(this.wordCount > 200){
        let words = newVal.split(' ').slice(0,200);
        this.input.name = words.join(' ');
      }
    }
  },
    computed: {
        hideTabs() {
            return (this.model.period_id == '');
        },
        saveText() {
            if (this.model.id) {
                return "Save";
            }

            return "Save";
        },
        words() {
            return this.model.result_inputs.length > 0 ? this.model.result_inputs.map(result_input => result_input.name.trim().split(/\s+/).filter(word => word != '')) : [];
        },
        showMsgBoxTwo() {
            this.$bvModal.show('modalSubmitted');
        },
        resultEdit() {
            if (this.editResult) {
                return "display: block;";
            } else {
                return "display: none;";
            }
        },
        challengeditor() {
            if (this.challengedit) {
                return "display: block;";
            } else {
                return "display: none;";
            }
        },
        riskeditor() {
            if (this.riskedit) {
                return "display: block;";
            } else {
                return "display: none;";
            }
        },
        resultShow() {
            if (this.editResult) {
                return "display: none;";
            } else {
                return "display: block;";
            }
        },
        Showchallange() {
            if (this.challengedit) {
                return "display: none;";
            } else {
                return "display: block;";
            }
        },
        Showrisk() {
            if (this.riskedit) {
                return "display: none;";
            } else {
                return "display: block;";
            }
        },
        implementationEdit() {
            if (this.editImplementation) {
                return "display: block;";
            } else {
                return "display: none;";
            }
        },
        implementationShow() {
            if (this.editImplementation) {
                return "display: none;";
            } else {
                return "display: block;";
            }
        },
        partnersEdit() {
            if (this.editPartners) {
                return "display: block;";
            } else {
                return "display: none;";
            }
        },
        partnersShow() {
            if (this.editPartners) {
                return "display: none;";
            } else {
                return "display: block;";
            }
        },
        milestoneEdit() {
            if (this.editMilestone) {
                return "display: block;";
            } else {
                return "display: none;";
            }
        },
        milestoneShow() {
            if (this.editMilestone) {
                return "display: none;";
            } else {
                return "display: block;";
            }
        },
        resultsShow() {
            if (this.editResult) {
                return "display: none;";
            } else {
                return "display: block;";
            }
        },
        Showrisks() {
            if (this.riskedit) {
                return "display: none;";
            } else {
                return "display: block;";
            }
        },
        resourcesEdit() {
            if (this.editResources) {
                return "display: block;";
            } else {
                return "display: none;";
            }
        },
        resourcesShow() {
            if (this.editResources) {
                return "display: none;";
            } else {
                return "display: block;";
            }
        },
        bestpracticesEdit() {
            if (this.editBestpractices) {
                return "display: block;";
            } else {
                return "display: none;";
            }
        },
        bestpracticesShow() {
            if (this.editBestpractices) {
                return "display: none;";
            } else {
                return "display: block;";
            }
        },
        opportunitiesEdit() {
            if (this.editOpportunities) {
                return "display: block;";
            } else {
                return "display: none;";
            }
        },
        opportunitiesShow() {
            if (this.editOpportunities) {
                return "display: none;";
            } else {
                return "display: block;";
            }
        },
        challengesEdit() {
            if (this.editChallenges) {
                return "display: block;";
            } else {
                return "display: none;";
            }
        },
        challengesShow() {
            if (this.editChallenges) {
                return "display: none;";
            } else {
                return "display: block;";
            }
        },
        gapsEdit() {
            if (this.editGaps) {
                return "display: block;";
            } else {
                return "display: none;";
            }
        },
        gapsShow() {
            if (this.editGaps) {
                return "display: none;";
            } else {
                return "display: block;";
            }
        },
        risksEdit() {
            if (this.editRisks) {
                return "display: block;";
            } else {
                return "display: none;";
            }
        },
        risksShow() {
            if (this.editRisks) {
                return "display: none;";
            } else {
                return "display: block;";
            }
        },
        projectEdit() {
            if (this.editproject) {
                return "display: block;";
            } else {
                return "display: none;";
            }
        },
        projectShow() {
            if (this.editproject) {
                return "display: none;";
            } else {
                return "display: block;";
            }
        },
        measEdit() {
            if (this.editMeas) {
                return "display: block;";
            } else {
                return "display: none;";
            }
        },
        measShow() {
            if (this.editMeas) {
                return "display: none;";
            } else {
                return "display: block;";
            }
        },
        nextstepsEdit() {
            if (this.editNextsteps) {
                return "display: block;";
            } else {
                return "display: none;";
            }
        },
        nextstepsShow() {
            if (this.editNextsteps) {
                return "display: none;";
            } else {
                return "display: block;";
            }
        },
    },
    watch: {
        words(newWords) {
            newWords.forEach((wordArray, index) => {
                if (wordArray.length > 200) {
                    this.model.result_inputs[index].name = wordArray.slice(0, 200).join(' ');
                }
            });
        }
    },
    created() {
        this.id = this.$route.params.id;
    },
    mounted() {
        this.fetchData(); 
        this.getImplementationplans();
        this.getMilestones();
        this.getResults();
        this.getResources();
        this.getResultCategories();
        this.getBestpractices();
        this.getOpportunities();
        this.getChallenges();
        this.getMeas();
        this.getProjects();
        this.getRisks();
        this.getKeylessons();
        this.getPartners(); 
        this.asyncGetMeas();
        this.getNextsteps(); 
        this.disablesubmit();
    },
    methods: {
        CountWords: function(obj, counterdiv, sbtbutton)
        {
             
            document.getElementById(counterdiv).innerHTML = obj.split(' ').length + ' words'
            if(obj.split(' ').length > 250)
            {
                //alert('You have exceeded the 250 word limit!');
                document.getElementById(counterdiv).innerHTML = obj.split(' ').length + ' words exceed the 250 word limit.'
                document.getElementById(counterdiv).style.color =  "red";
                document.getElementById(sbtbutton).disabled = true; 
            }
            else
            {
                
                document.getElementById(counterdiv).innerHTML = obj.split(' ').length + ' words'
                document.getElementById(counterdiv).style.color =  "black";
                document.getElementById(sbtbutton).disabled = false; 
            }
            //this.totalwords = this.risk.split(' ').length;
        }, 
        add(index) {
            this.model.inputs.push({ name: '' });
        },
        remove(index) {
            this.model.inputs.splice(index, 1);
        },
        addResult(index) {
            this.model.result_inputs.push({ name: '' });
        },
        removeResult(index) {
            this.model.result_inputs.splice(index, 1);
        },
        myFunction() {
            saveEditReports();
            showMsgBoxTwo();
        },
        hideeditImplementationplanModal() {
            this.$refs['mdl-editImplementationplan'].hide()
        },
		deleteImplementationplan(id) 
        { 
            event.preventDefault();  
            this.getImplementationplan(id);
            this.$refs['mdl-deleteImplementationplan'].show()
        },
        hidedeleteImplementationplanModal() {
            this.$refs['mdl-deleteImplementationplan'].hide()
        },
		showImplementationplanModal() {
        this.$refs['mdl-addImplementationplan'].show()
        },
        hideImplementationplanModal() {
            this.$refs['mdl-addImplementationplan'].hide()
        },
        editImplementationplan(id) 
        { 
            event.preventDefault();  
            this.getImplementationplan(id);
            this.$refs['mdl-editImplementationplan'].show()
        },
        showMilestoneModal() {
        this.$refs['mdl-addMilestone'].show()
        },
        hideMilestoneModal() {
            this.$refs['mdl-addMilestone'].hide()
        },
        editMilestone(id) 
        { 
            event.preventDefault();  
            this.getMilestone(id);
            this.$refs['mdl-editMilestone'].show()
        },
        hideeditMilestoneModal() {
            this.$refs['mdl-editMilestone'].hide()
        }, 
		deleteMilestone(id) 
        { 
            event.preventDefault();  
            this.getMilestone(id);
            this.$refs['mdl-deleteMilestone'].show()
        },
        hidedeleteMilestoneModal() {
            this.$refs['mdl-deleteMilestone'].hide()
        },
        showResultModal() {
        this.$refs['mdl-addResult'].show()
        },
        hideResultModal() {
            this.$refs['mdl-addResult'].hide()
        },
        editResult(id) 
        { 
            event.preventDefault();  
            this.getResult(id);
            this.$refs['mdl-editResult'].show()
        },
        hideeditResultModal() {
            this.$refs['mdl-editResult'].hide()
        }, 
		deleteResult(id) 
        { 
            event.preventDefault();  
            this.getResult(id);
            this.$refs['mdl-deleteResult'].show()
        },
        hidedeleteResultModal() {
            this.$refs['mdl-deleteResult'].hide()
        },
        hideeditResourceModal() {
            this.$refs['mdl-editResource'].hide()
        },
        hidedeleteResourceModal() {
            this.$refs['mdl-deleteResource'].hide()
        },
		showResourceModal() {
        this.$refs['mdl-addResource'].show()
        },
        hideResourceModal() {
            this.$refs['mdl-addResource'].hide()
        },
        editResource(id) 
        { 
            event.preventDefault();  
            this.getResource(id);
            this.$refs['mdl-editResource'].show()
        },
        deleteResource(id) 
        { 
            event.preventDefault();  
            this.getResource(id);
            this.$refs['mdl-deleteResource'].show()
        },
        hideeditBestpracticeModal() {
            this.$refs['mdl-editBestpractice'].hide()
        },
        hidedeleteBestpracticeModal() {
            this.$refs['mdl-deleteBestpractice'].hide()
        },
		showBestpracticeModal() {
        this.$refs['mdl-addBestpractice'].show()
        },
        hideBestpracticeModal() {
            this.$refs['mdl-addBestpractice'].hide()
        },
        editBestpractice(id) 
        { 
            event.preventDefault();  
            this.getBestpractice(id);
            this.$refs['mdl-editBestpractice'].show()
        },
		
		deleteBestpractice(id) 
        { 
            event.preventDefault();  
            this.getBestpractice(id);
            this.$refs['mdl-deleteBestpractice'].show()
        },
        hidedeleteBestpracticeModal() {
            this.$refs['mdl-deleteBestpractice'].hide()
        },
		hideeditOpportunityModal() {
            this.$refs['mdl-editOpportunity'].hide()
        },
        hidedeleteOpportunityModal() {
            this.$refs['mdl-deleteOpportunity'].hide()
        },
		showOpportunityModal() {
        this.$refs['mdl-addOpportunity'].show()
        },
        hideOpportunityModal() {
            this.$refs['mdl-addOpportunity'].hide()
        },
        editOpportunity(id) 
        { 
            event.preventDefault();  
            this.getOpportunity(id);
            this.$refs['mdl-editOpportunity'].show()
        },
        deleteOpportunity(id) 
        { 
            event.preventDefault();  
            this.getOpportunity(id);
            this.$refs['mdl-deleteOpportunity'].show()
        },
        hidedeleteOpportunityModal() {
            this.$refs['mdl-deleteOpportunity'].hide()
        },
        deleteChallenge(id) 
        { 
            event.preventDefault();  
            this.getChallenge(id);
            this.$refs['mdl-deleteChallenge'].show()
        },
        hideeditChallengeModal() {
            this.$refs['mdl-editChallenge'].hide()
        },
        hidedeleteChallengeModal() {
            this.$refs['mdl-deleteChallenge'].hide()
        },
		showChallengeModal() {
        this.$refs['mdl-addChallenge'].show()
        },
        hideChallengeModal() {
            this.$refs['mdl-addChallenge'].hide()
        },
        editChallenge(id) 
        { 
            event.preventDefault();  
            this.getChallenge(id);
            this.$refs['mdl-editChallenge'].show()
        },
        
        showRiskModal() {
        this.$refs['mdl-addRisk'].show()
        },
        hideRiskModal() {
            this.$refs['mdl-addRisk'].hide()
        },
        editRisk(id) 
        { 
            event.preventDefault();  
            this.getRisk(id);
            this.$refs['mdl-editRisk'].show()
        },
        deleteRisk(id) 
        { 
            event.preventDefault();  
            this.getRisk(id);
            this.$refs['mdl-deleteRisk'].show()
        },
        hidedeleteRiskModal() {
            this.$refs['mdl-deleteRisk'].hide()
        },
        hideeditRiskModal() {
            this.$refs['mdl-editRisk'].hide()
        },
        hideeditKeylessonModal() {
            this.$refs['mdl-editKeylesson'].hide()
        },
        hidedeleteKeylessonModal() {
            this.$refs['mdl-deleteKeylesson'].hide()
        },
		showKeylessonModal() {
        this.$refs['mdl-addKeylesson'].show()
        },
        hideKeylessonModal() {
            this.$refs['mdl-addKeylesson'].hide()
        },
        editKeylesson(id) 
        { 
            event.preventDefault();  
            this.getKeylesson(id);
            this.$refs['mdl-editKeylesson'].show()
        },
        deleteKeylesson(id) 
        { 
            event.preventDefault();  
            this.getKeylesson(id);
            this.$refs['mdl-deleteKeylesson'].show()
        },
        hidedeleteKeylessonModal() {
            this.$refs['mdl-deleteKeylesson'].hide()
        },
        showModal() {
        this.$refs['mdl-addPartner'].show()
        },
        hideModal() {
            this.$refs['mdl-addPartner'].hide()
        },
        editPartner(id) 
        { 
            event.preventDefault();  
            this.getPartner(id);
            this.$refs['mdl-editPartner'].show()
        },
        hideeditModal() {
            this.$refs['mdl-editPartner'].hide()
        },
        deletePartner(id) 
        { 
            event.preventDefault();  
            this.getPartner(id);
            this.$refs['mdl-deletePartner'].show()
        },
        hidedeletePartnerModal() {
            this.$refs['mdl-deletePartner'].hide()
        },
        showProjectModal() {
        this.$refs['mdl-addProject'].show()
        },
        hideProjectModal() {
            this.$refs['mdl-addProject'].hide()
        },
        editProject(id) 
        { 
            event.preventDefault();  
            this.getProject(id);
            this.$refs['mdl-editProject'].show()
        },
        hideeditProjectModal() {
            this.$refs['mdl-editProject'].hide()
        }, 
        hidedeleteProjectModal() {
            this.$refs['mdl-deleteProject'].hide()
        },
		deleteProject(id) 
        { 
            event.preventDefault();  
            this.getProject(id);
            this.$refs['mdl-deleteProject'].show()
        }, 
        showMeaModal() {
        this.$refs['mdl-addMea'].show()
        },
        hideMeaModal() {
            this.$refs['mdl-addMea'].hide()
        },
        editMea(id) 
        { 
            event.preventDefault();  
            this.getMea(id);
            this.$refs['mdl-editMea'].show()
        },
        hideeditMeaModal() {
            this.$refs['mdl-editMea'].hide()
        }, 
		deleteMea(id) 
        { 
            event.preventDefault();  
            this.getMea(id);
            this.$refs['mdl-deleteMea'].show()
        }, 
        hidedeleteMeaModal() {
            this.$refs['mdl-deleteMea'].hide()
        },
        hideeditNextstepModal() {
            this.$refs['mdl-editNextstep'].hide()
        },
        hidedeleteNextstepModal() {
            this.$refs['mdl-deleteNextstep'].hide()
        },
		showNextstepModal() {
        this.$refs['mdl-addNextstep'].show()
        },
        hideNextstepModal() {
            this.$refs['mdl-addNextstep'].hide()
        },
        editNextstep(id) 
        { 
            event.preventDefault();  
            this.getNextstep(id);
            this.$refs['mdl-editNextstep'].show()
        }, 
		deleteNextstep(id) 
        { 
            event.preventDefault();  
            this.getNextstep(id);
            this.$refs['mdl-deleteNextstep'].show()
        },
        hidedeleteNextstepModal() {
            this.$refs['mdl-deleteNextstep'].hide()
        },
         

        limitTextProjects(count) {
            return `and ${count} other projects`
        },
        limitTextMeas(count) {
            return `and ${count} other meas`
        },
        asyncFindProjects(query) {
            this.isLoadingProjects = true;
            let url = this.apiUrl;
            fetch(url + '/getprojectoptions?search=' + query)
                .then(res => res.json())
                .then(res => {
                    this.projectOptions = res;
                    this.isLoadingProjects = false;
                })
        },
        asyncFindMeas(query) {
            this.isLoadingMeas = true;
            let url = this.apiUrl;
            fetch(url + '/getmeassoptions?search=' + query)
                .then(res => res.json())
                .then(res => {
                    this.measOptions = res;
                    this.isLoadingMeas = false;
                })
        },
        asyncFindSdgs(query) {
            this.isLoadingSdgs = true;
            let url = this.apiUrl;
            fetch(url + '/getsdgsoptions?search=' + query)
                .then(res => res.json())
                .then(res => {
                    this.sdgsOptions = res;
                    this.isLoadingSdgs = false;
                })
        },
        getResultCategories() {
            this.resultCategoryOptions = [
                { "text": "Capacity Development / Technical Assistance", "value": "1" },
                { "text": "Convening / Partnerships / Knowledge Sharing", "value": "2" },
                { "text": "Data Collection and Analysis", "value": "3" },
                { "text": "Direct support / Service Delivery", "value": "4" },
                { "text": "Innovative Approaches", "value": "5" },
                { "text": "Institutional Mechanism and System Building", "value": "6" },
                { "text": "Normative Support", "value": "7" },
                { "text": "Optimising Financing", "value": "8" },
                { "text": "Policy Advice", "value": "9" },
                { "text": "Risk Analysis", "value": "10" },
                { "text": "Support Functions", "value": "11" },
                { "text": "Thought Leadership", "value": "12" },
                { "text": "UN Agency Integration", "value": "13" },
                { "text": "Other", "value": "14" }
            ];
            this.riskCategoryOptions = [
                { "text": "", "value": "0" },
                { "text": "Strategic Risks", "value": "10" },
                { "text": "Operational Risks/ Implementation Risks", "value": "20" },
                { "text": "Administrative Risks", "value": "30" },
                { "text": "Scope Risks", "value": "40" },
                { "text": "Scheduling Risks", "value": "50" },
                { "text": "Resource Risks", "value": "60" },
                { "text": "Other ", "value": "70" }
            ];
            this.challengeCategoryOptions = [
                { "text": "", "value": "0" },
                { "text": "Delayed or Insufficient Funding", "value": "10" },
                { "text": "Collaboration with Implementing Partners", "value": "20" },
                { "text": "Resolutions design issues", "value": "30" },
                { "text": "Engagement of Recipient country/ organization/ institution", "value": "40" },
                { "text": "Stability of countries involved", "value": "50" },
                { "text": "Data availability / sharing", "value": "60" },
                { "text": "Administrative processes", "value": "70" },
                { "text": "Other ", "value": "80" }
            ];
            this.partnersCategoryOptions = [
                { "text": "", "value": "0" },
                { "text": "Foundation (Corporate Philanthropic)", "value": "10" },
                { "text": "Foundation (Other)", "value": "20" },
                { "text": "Government", "value": "30" },
                { "text": "Inter-Governmental Organization", "value": "40" },
                { "text": "International Non Profit Association", "value": "50" },
                { "text": "International Organization", "value": "60" },
                { "text": "Not for Profit", "value": "70" },
                { "text": "Private Sector ", "value": "80" },
                { "text": "Private University ", "value": "90" },
                { "text": "Public University ", "value": "100" },
                { "text": "Trust ", "value": "110" },
                { "text": "UN Agency ", "value": "120" },
                { "text": "University (Not for profit) ", "value": "120" } 

            ];
        },
        clearAllProjects() {
            this.model.projects_ids = []
        },
        clearAllMeas() {
            this.model.meas_ids = []
        },
        clearAllSdgs() {
            this.model.sdg_outcome = []
        },
        clearAllResultCategory() {
            this.model.result_ids = []
        },
        getLoggedInUserId() {
            let loggedInUserId = document.getElementById('loggedInUserId');
            return loggedInUserId == null ? 'guest' : loggedInUserId.value;
        },
        getLoggedInUserEmail() {
            let loggedInUserEmail = document.getElementById('loggedInUserEmail');
            return loggedInUserEmail == null ? '' : loggedInUserEmail.value;
        },
        getLoggedInUserName() {
            let loggedInUserName = document.getElementById('loggedInUserName');
            return loggedInUserName == null ? '' : loggedInUserName.value;
        },
        loadReport() 
        {
            let url = this.apiUrl;
            fetch(url + '/getreport?type=1&outcome_id=' + this.id + "&period_id=" + this.model.period_id + "&loggedInUserId=" + this.getLoggedInUserId() + "&loggedInUserName=" + this.getLoggedInUserName() + "&loggedInUserEmail=" + this.getLoggedInUserEmail())
                .then(res => res.json())
                .then(res => {
                    for (let key in res['data']['model']) {
                        if (key == 'period_id') continue;
                        this.model[key] = res['data']['model'][key];
                    }
                })
                .catch(error => {
                    console.log(error)
                });

                
            this.getImplementationplans();
            this.getMilestones();
            this.getResults();
            this.getResources();
            this.getResultCategories();
            this.getBestpractices();
            this.getOpportunities();
            this.getChallenges();
            this.getMeas();
            this.getProjects();
            this.getRisks();
            this.getKeylessons();
            this.getPartners(); 
            this.asyncGetMeas();
            this.getNextsteps();  
            this.disablesubmit();
        },
        fetchData() {
            let url = this.apiUrl;
            fetch(url + '/getoutcome?id=' + this.id)
                .then(res => res.json())
                .then(res => {
                    this.modelData = res['data'];
                    this.meaOptions = this.modelData['meaOptions'];
                    this.sdgsOptions = this.modelData['sdg_outcome'];
                    this.milestonesOptions = this.modelData['milestonesOptions'];
                });
        }, 
        getImplementationplans(){
            this.implementationplans_data =[];
            let url = this.apiUrl + '/getimplementationplans/' + this.id + "_" + this.model.period_id;  
            axios.get(url).then((response) => 
            {   
                if(response.data )
                {
                    this.implementationplans_data = response.data;                  
                }
                else
                {
                    this.implementationplans_data = "";
                } 
            });
        },
        getMilestones(){
            this.milestones_data =[];
            let url = this.apiUrl + '/getmilestones/' + this.id + "_" + this.model.period_id;  
            axios.get(url).then((response) => 
            {
                if(response.data )
                {
                    this.milestones_data = response.data;                  
                }
                else
                {
                    this.milestones_data = "";
                } 
            });
        },
        getResults(){
            this.results_data =[];
            let url = this.apiUrl + '/getresults/' + this.id + "_" + this.model.period_id;  
            axios.get(url).then((response) => 
            {
                if(response.data )
                {
                    this.results_data = response.data;                  
                }
                else
                {
                    this.results_data = "";
                } 
            });
        }, 
        getResources(){
            this.resources_data =[];
            let url = this.apiUrl + '/getresources/' + this.id + "_" + this.model.period_id;  
            axios.get(url).then((response) => 
            {   
                if(response.data )
                {
                    this.resources_data = response.data;                  
                }
                else
                {
                    this.resources_data = "";
                }
            });
        },
        getBestpractices(){
            this.bestpractices_data =[];
            let url = this.apiUrl + '/getbestpractices/' + this.id + "_" + this.model.period_id;  
            axios.get(url).then((response) => 
            {
                if(response.data )
                {
                    this.bestpractices_data = response.data;                  
                }
                else
                {
                    this.bestpractices_data = "";
                } 
            });
        }, 
		
		
        getOpportunities(){
            this.opportunities_data =[];
            let url = this.apiUrl + '/getopportunities/' + this.id + "_" + this.model.period_id;  
            axios.get(url).then((response) => 
            {
                if(response.data)
                {
                    this.opportunities_data = response.data;                  
                }
                else
                {
                    this.opportunities_data = "";
                }   
            });
        }, 
        getChallenges(){
            this.challenges_data = [];
            let url = this.apiUrl + '/getchallenges/' + this.id + "_" + this.model.period_id;  
            axios.get(url).then((response) => 
            {   
                if(response.data)
                {
                    this.challenges_data = response.data;                  
                }
                else
                {
                    this.challenges_data = "";
                }   
             }); 
        },
        getRisks(){
            this.risks_data =[];
            let url = this.apiUrl + '/getrisks/' + this.id + "_" + this.model.period_id;  
            axios.get(url).then((response) => 
            {
                if(response.data)
                {
                    this.risks_data = response.data;                  
                }
                else
                {
                    this.risks_data = "";
                }   
            });
        },  
        getKeylessons(){
            this.keylessons_data =[];
            let url = this.apiUrl + '/getkeylessons/' + this.id + "_" + this.model.period_id;  
            axios.get(url).then((response) => 
            {
                if(response.data)
                {
                    this.keylessons_data = response.data;                  
                }
                else
                {
                    this.keylessons_data = "";
                }   
            });
        },      
        getPartners(){
            this.partners_data =[];
             let url = this.apiUrl + '/getpartners/' + this.id + "_" + this.model.period_id;  
            axios.get(url).then((response) => 
            {
                if(response.data)
                {
                    this.partners_data = response.data;                  
                }
                else
                {
                    this.partners_data = "";
                }   
                //$("#partners_table").DataTable();
            });
        },  
        getProjects(){
            this.projects_data =[];
             let url = this.apiUrl + '/getprojects/' + this.id + "_" + this.model.period_id;  
            axios.get(url).then((response) => 
            {
                if(response.data)
                {
                    this.projects_data = response.data;                  
                }
                else
                {
                    this.projects_data = "";
                }   
                //$("#partners_table").DataTable();
            });
        },  
        getMeas(){
            this.meas_data =[];
             let url = this.apiUrl + '/getmeas/' + this.id + "_" + this.model.period_id;  
            axios.get(url).then((response) => 
            {
                if(response.data)
                {
                    this.meas_data = response.data;                  
                }
                else
                {
                    this.meas_data = "";
                }   
                //$("#partners_table").DataTable();
            });
        },  
        asyncGetMeas(){ 
            this.measOptions =[];
             let url = this.apiUrl + '/getallmeasoptions/' + this.id + "_" + this.model.period_id;  
            axios.get(url).then((response) => 
            {
                this.measOptions = response.data;
                //$("#partners_table").DataTable();
            });
        },  
        getNextsteps(){
            this.nextsteps_data =[];
            let url = this.apiUrl + '/getnextsteps/' + this.id + "_" + this.model.period_id;  
            axios.get(url).then((response) => 
            {
                if(response.data)
                {
                    this.nextsteps_data = response.data;                  
                }
                else
                {
                    this.nextsteps_data = "";
                }   
            });
        }, 
        disablesubmit(){
            document.getElementById("submittedButton").disabled = true; 
            document.getElementById("submittedButton").style.color = "#cccccc";
        }, 
        submitReports: function () {
            //if (confirm("Are you sure you want to submit?")) {
            this.submittingInfo = true;
            this.submittingMessage = '';

            /*if (!this.$refs.form.checkValidity()) {
                this.submittingInfo = false;
                return
            }*/
            // let url = this.apiUrl + '/addreportsecretariat/' + this.id + "?period_id=" + this.model.period_id + "&loggedInUserId=" + this.getLoggedInUserId() + "&loggedInUserName=" + this.getLoggedInUserName() + "&loggedInUserEmail=" + this.getLoggedInUserEmail();

            let url = this.apiUrl + '/addreportsecretariat/' + this.id + "?period_id=" + this.model.period_id + "&loggedInUserId=" + this.getLoggedInUserId() + "&loggedInUserName=" + encodeURIComponent(this.getLoggedInUserName()) + "&loggedInUserEmail=" + encodeURIComponent(this.getLoggedInUserEmail());


            console.log("Submitting to URL:", url);
            console.log("Report Data being submitted:", JSON.parse(JSON.stringify(this.model)));
            
            fetch(url, {
                method: 'post',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(this.model)
                
            })
                .then((res) => {
                    console.log("Data being submitted111:", res);
                    if (!res.ok) {
                        throw new Error("HTTP status " + res.status);
                    }
                    return res.json();
                })
                .then(res => {
                    console.log("Data being submitted222:", res);
                    this.submittingInfo = false;
                    if (res.success) {
                        this.submittingMessage = "<span style='color: green;'>" + (this.id > 0 ? 'Saved' : 'saved') + " successfully.</span>";
                        disablesubmit();
                    } else {
                        this.submittingMessage = "<span style='color: red;'>Error occurred: " + res.message + "</span>";
                    }
                }).catch(error => {
                    this.submittingInfo = false;
                    this.submittingMessage = "<span style='color: red;'>Error occurred: " + error + "</span>";
                });
            // }
        },
        enableSubmit(e) 
        {
            if($("#agree").is(":checked")) 
            { 
                document.getElementById("submittedButton").disabled = false;   
                document.getElementById("submittedButton").style.color = "#ffffff";
            }
            else
            {                
                document.getElementById("submittedButton").disabled = true; 
                document.getElementById("submittedButton").style.color = "#cccccc";
            }
        
        },
        addImplementationplan: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/addimplementationplans/' + this.id; 
            
            var formData = {
                'implementationplan'			: this.implementationplan,  
                "period_id": this.model.period_id 
            };
           
            
            // process the form
            $.ajax({
                type: 'POST',
                url: url,
                data: formData,
                dataType: 'json',
                encode: true,
                success: (data) => {
                    
                    this.getImplementationplans();  
                    this.hideImplementationplanModal(); 
                    this.implementationplan = ""; 
                },
                error: (error) => {
                     
                }, 
            })
            .done(function (data) { 
               
            });
        },
        modifyImplementationplan: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/editimplementationplans/' + this.implementationplan_id; 
            let implementationplan = $("#implementationplan").val(); 
            this.implementationplan; 
 
             
            var formData = {
                'implementationplan'			:  implementationplan, 
            };
           
            if((implementationplan != ""))
            {

                // process the form
                $.ajax({
                    type: 'POST',
                    url: url,
                    data: formData,
                    dataType: 'json',
                    encode: true,
                    success: (data) => {
                        
                        
                        this.getImplementationplans(); 
                        this.hideeditImplementationplanModal();  
                        this.implementationplan = ""; 
                    },
                    error: (error) => {
                        
                    }, 
                })
                .done(function (data) { 
                
                });
            }
        },
        delImplementationplan: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/deleteimplementationplan/' + this.implementationplan_id; 
             
            

                // process the form
                $.ajax({
                    type: 'GET',
                    url: url, 
                    dataType: 'json',
                    encode: true,
                    success: (data) => {
                        
                        
                        this.getImplementationplans(); 
                        this.hidedeleteImplementationplanModal();   
                    },
                    error: (error) => {
                        
                    }, 
                })
                .done(function (data) { 
                
                }); 
        },
        getImplementationplan(id){
            let url = this.apiUrl + '/getimplementationplan/' + id; 
             this.implementationplan_id = id;
             // process the form
             $.ajax( url )
            .done(function(resp) { 
                $('#implementationplan').val(resp[0].implementationplan);  
            }) ;  
            
        },    
        
        addMilestone: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/addmilestones/' + this.id; 

            var formData = {
                'milestone_text'			: this.milestone_text,
                'milestone_status_id': this.milestone_status_id, 
                "period_id": this.model.period_id 
            };
           
            
            // process the form
            $.ajax({
                type: 'POST',
                url: url,
                data: formData,
                dataType: 'json',
                encode: true,
                success: (data) => {
                    
                    this.getMilestones();  
                    this.hideMilestoneModal(); 
                    this.milestone_text = "";
                    this.milestone_status_id = ""; 
                },
                error: (error) => {
                     
                }, 
            })
            .done(function (data) { 
               
            });
        },
        modifyMilestone: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/editmilestones/' + this.milestone_id; 
            let milestone_text = $("#milestone_text").val();//this.milestone_text;
            let milestone_status_id = $("#milestone_status_id").val();//this.milestone_status_id;
            var formData = {
                'milestone_text'			:  milestone_text,
                'milestone_status_id': milestone_status_id 
            };
            
            if((milestone_text != "") && (milestone_status_id != ""))
            {
                // process the form
                $.ajax({
                    type: 'POST',
                    url: url,
                    data: formData,
                    dataType: 'json',
                    encode: true,
                    success: (data) => {
                        
                        this.hideeditMilestoneModal(); 
                        this.getMilestones();  
                        this.milestone_text = "";
                        this.milestone_status_id = ""; 
                    },
                    error: (error) => {
                        
                    }, 
                })
                .done(function (data) { 
                
                });
            }
        },
        delMilestone: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/deletemilestone/' + this.milestone_id; 
             
            

                // process the form
                $.ajax({
                    type: 'GET',
                    url: url, 
                    dataType: 'json',
                    encode: true,
                    success: (data) => {
                        
                        
                        this.getMilestones(); 
                        this.hidedeleteMilestoneModal();   
                    },
                    error: (error) => {
                        
                    }, 
                })
                .done(function (data) { 
                
                }); 
        },
        getMilestone(id){
            let url = this.apiUrl + '/getmilestone/' + id; 
             this.milestone_id = id;
             // process the form
             $.ajax( url )
            .done(function(resp) { 
                $('#milestone_text').val(resp[0].milestone_text); 
                $('#milestone_status_id').val(resp[0].status_id); 
            }) ;  
            
        }
        ,addResult: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/addresults/' + this.id; 

            var formData = {
                'result_text'			: this.result_text,
                'result_category_id': this.result_category_id, 
                "period_id": this.model.period_id 
            };
           
            
            // process the form
            $.ajax({
                type: 'POST',
                url: url,
                data: formData,
                dataType: 'json',
                encode: true,
                success: (data) => {
                    
                    this.getResults();  
                    this.hideResultModal(); 
                    this.result_text = "";
                    this.result_category_id = ""; 
                },
                error: (error) => {
                     
                }, 
            })
            .done(function (data) { 
               
            });
        },
        modifyResult: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/editresults/' + this.result_id; 
            let result_text = $("#result_text").val();//this.result_text;
            let result_category_id = $("#result_category_id").val();//this.result_category_id;
            var formData = {
                'result_text'			:  result_text,
                'result_category_id': result_category_id 
            };
            
            if((result_text != "") && (result_category_id != ""))
            {
                // process the form
                $.ajax({
                    type: 'POST',
                    url: url,
                    data: formData,
                    dataType: 'json',
                    encode: true,
                    success: (data) => {
                        
                        this.hideeditResultModal(); 
                        this.getResults();  
                        this.result_text = "";
                        this.result_category_id = ""; 
                    },
                    error: (error) => {
                        
                    }, 
                })
                .done(function (data) { 
                
                });
            }
        },
        delResult: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/deleteresult/' + this.result_id; 
             
            

                // process the form
                $.ajax({
                    type: 'GET',
                    url: url, 
                    dataType: 'json',
                    encode: true,
                    success: (data) => {
                        
                        
                        this.getResults(); 
                        this.hidedeleteResultModal();   
                    },
                    error: (error) => {
                        
                    }, 
                })
                .done(function (data) { 
                
                }); 
        },
        getResult(id){
            let url = this.apiUrl + '/getresult/' + id; 
             this.result_id = id;
             // process the form
             $.ajax( url )
            .done(function(resp) { 
                $('#result_text').val(resp[0].result_text); 
                $('#result_category_id').val(resp[0].result_category_id); 
            }) ;  
            
        },
        addResource: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/addresources/' + this.id; 
            
            var formData = {
                'resource1'			: this.resource1,
                'resource2'			: this.resource2,
                'resource_category_id1': 'Within Existing Resources', 
                'resource_category_id2': 'Additional Resources Required', 
                "period_id": this.model.period_id 
            };
           
            
            // process the form
            $.ajax({
                type: 'POST',
                url: url,
                data: formData,
                dataType: 'json',
                encode: true,
                success: (data) => {
                    
                    this.getResources();  
                    this.hideResourceModal(); 
                    this.resource1 = "";
                    this.resource2 = ""; 
                },
                error: (error) => {
                     
                }, 
            })
            .done(function (data) { 
               
            });
        },
        modifyResource: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/editresources/' + this.resource_id; 
            let resource1 = 'Within Existing Resources';
            let resource2 = 'Additional Resources Required';
            this.resource1;
            this.resource2;
            let resource_category_id1 = 'Within Existing Resources';
            this.resource_category_id1;
            let resource_category_id2 = 'Additional Resources Required';
            this.resource_category_id2;
 
             
            var formData = {
                'resource1'			:  resource1,
                'resource2'			:  resource2,
                'resource_category_id1': 'Within Existing Resources', 
                'resource_category_id2': 'Additional Resources Required'
            };
           
            if((resource1 != "") && (resource_category_id1 != ""))
            {

                // process the form
                $.ajax({
                    type: 'POST',
                    url: url,
                    data: formData,
                    dataType: 'json',
                    encode: true,
                    success: (data) => {
                        
                        
                        this.getResources(); 
                        this.hideeditResourceModal();  
                        this.resource1 = "";
                        this.resource2 = ""; 
                    },
                    error: (error) => {
                        
                    }, 
                })
                .done(function (data) { 
                
                });
            }
        },
        delResource: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/deleteresource/' + this.resource_id; 
             
            

                // process the form
                $.ajax({
                    type: 'GET',
                    url: url, 
                    dataType: 'json',
                    encode: true,
                    success: (data) => {
                        
                        
                        this.getResources(); 
                        this.hidedeleteResourceModal();   
                    },
                    error: (error) => {
                        
                    }, 
                })
                .done(function (data) { 
                
                }); 
        },
        getResource(id){
            let url = this.apiUrl + '/getresource/' + id; 
             this.resource_id = id;
             // process the form
             $.ajax( url )
            .done(function(resp) { 
                $('#resource1').val(resp[0].resource1); 
                $('#resource2').val(resp[0].resource2);
                $('#resource_category_id1').val(resp[0].resource_category_id1); 
                $('#resource_category_id2').val(resp[0].resource_category_id2); 
            }) ;  
            
        },     
        addBestpractice: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/addbestpractice/' + this.id; 
            
            var formData = {
                'bestpractice'			: this.bestpractice,  
                "period_id": this.model.period_id 
            };
           
            
            // process the form
            $.ajax({
                type: 'POST',
                url: url,
                data: formData,
                dataType: 'json',
                encode: true,
                success: (data) => {
                    
                    this.getBestpractices();  
                    this.hideBestpracticeModal(); 
                    this.bestpractice = ""; 
                },
                error: (error) => {
                     
                }, 
            })
            .done(function (data) { 
               
            });
        },
        modifyBestpractice: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/editbestpractice/' + this.bestpractice_id; 
            let bestpractice = $("#bestpractice").val(); 
            this.bestpractice; 
 
             
            var formData = {
                'bestpractice'			:  bestpractice, 
            };
           
            if((bestpractice != ""))
            {

                // process the form
                $.ajax({
                    type: 'POST',
                    url: url,
                    data: formData,
                    dataType: 'json',
                    encode: true,
                    success: (data) => {
                        
                        
                        this.getBestpractices(); 
                        this.hideeditBestpracticeModal();  
                        this.bestpractice = ""; 
                    },
                    error: (error) => {
                        
                    }, 
                })
                .done(function (data) { 
                
                });
            }
        },
        delBestpractice: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/deletebestpractice/' + this.bestpractice_id; 
             
            

                // process the form
                $.ajax({
                    type: 'GET',
                    url: url, 
                    dataType: 'json',
                    encode: true,
                    success: (data) => {
                        
                        
                        this.getBestpractices(); 
                        this.hidedeleteBestpracticeModal();   
                    },
                    error: (error) => {
                        
                    }, 
                })
                .done(function (data) { 
                
                }); 
        },
        getBestpractice(id){
            let url = this.apiUrl + '/getbestpractice/' + id; 
             this.bestpractice_id = id;
             // process the form
             $.ajax( url )
            .done(function(resp) { 
                $('#bestpractice').val(resp[0].bestpractice);  
            }) ;  
            
        },  
        addOpportunity: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/addopportunity/' + this.id; 
            
            var formData = {
                'opportunity'			: this.opportunity,  
                "period_id": this.model.period_id 
            };
           
            
            // process the form
            $.ajax({
                type: 'POST',
                url: url,
                data: formData,
                dataType: 'json',
                encode: true,
                success: (data) => {
                    
                    this.getOpportunities();  
                    this.hideOpportunityModal(); 
                    this.opportunity = ""; 
                },
                error: (error) => {
                     
                }, 
            })
            .done(function (data) { 
               
            });
        },
        modifyOpportunity: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/editopportunity/' + this.opportunity_id; 
            let opportunity = $("#opportunity").val(); 
            this.opportunity; 
 
             
            var formData = {
                'opportunity'			:  opportunity, 
            };
           
            if((opportunity != ""))
            {

                // process the form
                $.ajax({
                    type: 'POST',
                    url: url,
                    data: formData,
                    dataType: 'json',
                    encode: true,
                    success: (data) => {
                        
                        
                        this.getOpportunities(); 
                        this.hideeditOpportunityModal();  
                        this.opportunity = ""; 
                    },
                    error: (error) => {
                        
                    }, 
                })
                .done(function (data) { 
                
                });
            }
        },
        delOpportunity: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/deleteopportunity/' + this.opportunity_id; 
             
            

                // process the form
                $.ajax({
                    type: 'GET',
                    url: url, 
                    dataType: 'json',
                    encode: true,
                    success: (data) => {
                        
                        
                        this.getOpportunities(); 
                        this.hidedeleteOpportunityModal();   
                    },
                    error: (error) => {
                        
                    }, 
                })
                .done(function (data) { 
                
                }); 
        },
        getOpportunity(id){
            let url = this.apiUrl + '/getopportunity/' + id; 
             this.opportunity_id = id;
             // process the form
             $.ajax( url )
            .done(function(resp) { 
                $('#opportunity').val(resp[0].opportunity);  
            }) ;  
            
        },  


        
        addChallenge: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/addchallenges/' + this.id; 

            var formData = {
                'challenge'			: this.challenge,
                'challenge_category_id': this.challenge_category_id, 
                "period_id": this.model.period_id 
            };
           
            
            // process the form
            $.ajax({
                type: 'POST',
                url: url,
                data: formData,
                dataType: 'json',
                encode: true,
                success: (data) => {
                    
                    this.getChallenges();  
                    this.hideChallengeModal(); 
                    this.challenge = "";
                    this.challenge_category_id = ""; 
                },
                error: (error) => {
                     
                }, 
            })
            .done(function (data) { 
               
            });
        },
        modifyChallenge: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/editchallenges/' + this.challenge_id; 
            let challenge = $("#challenge").val();this.challenge;
            let challenge_category_id = $("#challenge_category_id").val();this.challenge_category_id;
 
             
            var formData = {
                'challenge'			:  challenge,
                'challenge_category_id':  challenge_category_id 
            };
           
            if((challenge != "") && (challenge_category_id != ""))
            {

                // process the form
                $.ajax({
                    type: 'POST',
                    url: url,
                    data: formData,
                    dataType: 'json',
                    encode: true,
                    success: (data) => {
                        
                        
                        this.getChallenges(); 
                        this.hideeditChallengeModal();  
                        this.challenge = "";
                        this.challenge_category_id = ""; 
                    },
                    error: (error) => {
                        
                    }, 
                })
                .done(function (data) { 
                
                });
            }
        },
        delChallenge: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/deletechallenge/' + this.challenge_id; 
             
            

                // process the form
                $.ajax({
                    type: 'GET',
                    url: url, 
                    dataType: 'json',
                    encode: true,
                    success: (data) => {
                        
                        
                        this.getChallenges(); 
                        this.hidedeleteChallengeModal();   
                    },
                    error: (error) => {
                        
                    }, 
                })
                .done(function (data) { 
                
                }); 
        },
        getChallenge(id){
            let url = this.apiUrl + '/getchallenge/' + id; 
             this.challenge_id = id;
             // process the form
             $.ajax( url )
            .done(function(resp) { 
                $('#challenge').val(resp[0].challenge); 
                $('#challenge_category_id').val(resp[0].challenge_category); 
            }) ;  
            
        },   
        addRisk: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/addrisks/' + this.id; 

            var formData = {
                'risk'			: this.risk,
                'risk_category_id': this.risk_category_id, 
                "period_id": this.model.period_id 
            };
           
            
            // process the form
            $.ajax({
                type: 'POST',
                url: url,
                data: formData,
                dataType: 'json',
                encode: true,
                success: (data) => {
                    
                    this.getRisks();  
                    this.hideRiskModal(); 
                    this.risk = "";
                    this.risk_category_id = ""; 
                },
                error: (error) => {
                     
                }, 
            })
            .done(function (data) { 
               
            });
        },
        modifyRisk: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/editrisks/' + this.risk_id; 
            let risk = $("#risk").val();//this.risk;
            let risk_category_id = $("#risk_category_id").val();//this.risk_category_id;
            var formData = {
                'risk'			:  risk,
                'risk_category_id': risk_category_id 
            };
            
            if((risk != "") && (risk_category_id != ""))
            {
                // process the form
                $.ajax({
                    type: 'POST',
                    url: url,
                    data: formData,
                    dataType: 'json',
                    encode: true,
                    success: (data) => {
                        
                        this.hideeditRiskModal(); 
                        this.getRisks();  
                        this.risk = "";
                        this.risk_category_id = ""; 
                    },
                    error: (error) => {
                        
                    }, 
                })
                .done(function (data) { 
                
                });
            }
        },
        delRisk: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/deleterisk/' + this.risk_id; 
             
            

                // process the form
                $.ajax({
                    type: 'GET',
                    url: url, 
                    dataType: 'json',
                    encode: true,
                    success: (data) => {
                        
                        
                        this.getRisks(); 
                        this.hidedeleteRiskModal();   
                    },
                    error: (error) => {
                        
                    }, 
                })
                .done(function (data) { 
                
                }); 
        },
        getRisk(id){
            let url = this.apiUrl + '/getrisk/' + id; 
             this.risk_id = id;
             // process the form
             $.ajax( url )
            .done(function(resp) { 
                $('#risk').val(resp[0].risk); 
                $('#risk_category_id').val(resp[0].risk_category); 
            }) ;  
            
        }, 
        addKeylesson: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/addkeylesson/' + this.id; 
            
            var formData = {
                'keylesson'			: this.keylesson,  
                "period_id": this.model.period_id 
            };
           
            
            // process the form
            $.ajax({
                type: 'POST',
                url: url,
                data: formData,
                dataType: 'json',
                encode: true,
                success: (data) => {
                    
                    this.getKeylessons();  
                    this.hideKeylessonModal(); 
                    this.keylesson = ""; 
                },
                error: (error) => {
                     
                }, 
            })
            .done(function (data) { 
               
            });
        },
        modifyKeylesson: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/editkeylesson/' + this.keylesson_id; 
            let keylesson = $("#keylesson").val(); 
            this.keylesson; 
 
             
            var formData = {
                'keylesson'			:  keylesson, 
            };
           
            if((keylesson != "") )
            {

                // process the form
                $.ajax({
                    type: 'POST',
                    url: url,
                    data: formData,
                    dataType: 'json',
                    encode: true,
                    success: (data) => {
                        
                        
                        this.getKeylessons(); 
                        this.hideeditKeylessonModal();  
                        this.keylesson = ""; 
                    },
                    error: (error) => {
                        
                    }, 
                })
                .done(function (data) { 
                
                });
            }
        },
        delKeylesson: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/deletekeylesson/' + this.keylesson_id; 
             
            

                // process the form
                $.ajax({
                    type: 'GET',
                    url: url, 
                    dataType: 'json',
                    encode: true,
                    success: (data) => {
                        
                        
                        this.getKeylessons(); 
                        this.hidedeleteKeylessonModal();   
                    },
                    error: (error) => {
                        
                    }, 
                })
                .done(function (data) { 
                
                }); 
        },
        getKeylesson(id){
            let url = this.apiUrl + '/getkeylesson/' + id; 
             this.keylesson_id = id;
             // process the form
             $.ajax( url )
            .done(function(resp) { 
                $('#keylesson').val(resp[0].keylesson);  
            }) ;  
            
        },  
        addPartner: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/addpartners/' + this.id; 

            var formData = {
                'partner'			: this.partner,
                'partner_category_id': this.partner_category_id ,
                "period_id": this.model.period_id
            };
           
            
            // process the form
            $.ajax({
                type: 'POST',
                url: url,
                data: formData,
                dataType: 'json',
                encode: true,
                success: (data) => {
                    
                    this.getPartners();  
                    this.hideModal(); 
                    this.partner = "";
                    this.partner_category_id = ""; 
                },
                error: (error) => {
                     
                }, 
            })
            .done(function (data) { 
               
            });
        },
        modifyPartner: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/editpartners/' + this.partner_id; 

            let partner = $("#partner").val();//this.partner;
            let partner_category_id = $("#partner_category_id").val();//this.partner_category_id;
 
             
            var formData = {
                'partner'			:  partner,
                'partner_category_id':  partner_category_id 
            };
           
            if((partner != "") && (partner_category_id != ""))
            { 
            
                // process the form
                $.ajax({
                    type: 'POST',
                    url: url,
                    data: formData,
                    dataType: 'json',
                    encode: true,
                    success: (data) => {
                        
                        this.hideeditModal(); 
                        this.getPartners();  
                        this.partner = "";
                        this.partner_category_id = ""; 
                    },
                    error: (error) => {
                        
                    }, 
                })
                .done(function (data) { 
                
                });
            }
        },
        delPartner: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/deletepartner/' + this.partner_id; 
             
            

                // process the form
                $.ajax({
                    type: 'GET',
                    url: url, 
                    dataType: 'json',
                    encode: true,
                    success: (data) => {
                        
                        
                        this.getPartners(); 
                        this.hidedeletePartnerModal();   
                    },
                    error: (error) => {
                        
                    }, 
                })
                .done(function (data) { 
                
                }); 
        },
        getPartner(id){
            let url = this.apiUrl + '/getpartner/' + id; 
             this.partner_id = id;
             // process the form
             $.ajax( url )
            .done(function(resp) { 
                $('#partner').val(resp[0].partner); 
                $('#partner_category_id').val(resp[0].partner_category); 
            }) ;  
            
        },
        addProject: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/addprojects/' + this.id; 

            var formData = { 
                'proj_id'			:  this.proj_id,  
                'project_name': this.project_name, 
                "period_id": this.model.period_id 
            };
            
            // process the form
            $.ajax({
                type: 'POST',
                url: url,
                data: formData,
                dataType: 'json',
                encode: true,
                success: (data) => {
                    
                    this.getProjects();  
                    this.hideProjectModal();   
                    this.proj_id = "";
                    this.project_name = ""; 
                },
                error: (error) => {
                     
                }, 
            })
            .done(function (data) { 
               
            });
        },
        modifyProject: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/editprojects/' + this.project_id; 
            let project_name = $("#project_name").val();//this.project_text;
            let proj_id = $("#proj_id").val();//this.project_category_id;
            var formData = {
                'proj_id'			:  this.proj_id,  
                'project_name': this.project_name, 
            };
            
            if((proj_id != "") && (project_name != ""))
            {
                // process the form
                $.ajax({
                    type: 'POST',
                    url: url,
                    data: formData,
                    dataType: 'json',
                    encode: true,
                    success: (data) => {
                        
                        this.hideeditProjectModal(); 
                        this.getProjects();  
                        this.proj_id = "";
                        this.project_name = ""; 
                    },
                    error: (error) => {
                        
                    }, 
                })
                .done(function (data) { 
                
                });
            }
        },
        delProject: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/deleteproject/' + this.project_id; 
             
            

                // process the form
                $.ajax({
                    type: 'GET',
                    url: url, 
                    dataType: 'json',
                    encode: true,
                    success: (data) => {
                        
                        
                        this.getProjects(); 
                        this.hidedeleteProjectModal();    
                    },
                    error: (error) => {
                        
                    }, 
                })
                .done(function (data) { 
                
                }); 
        },
        getProject(id){
            let url = this.apiUrl + '/getproject/' + id; 
             this.project_id = id;
             // process the form
             $.ajax( url )
            .done(function(resp) {  
                $('#proj_id').val(resp[0].project_id); 
                $('#project_name').val(resp[0].project_name); 
            }) ;  
            
        }, 
        addMea: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/addmeas/' + this.id; 

            var formData = { 
                'meas_ids': this.meas_ids, 
                "period_id": this.model.period_id 
            };
           
            
            // process the form
            $.ajax({
                type: 'POST',
                url: url,
                data: formData,
                dataType: 'json',
                encode: true,
                success: (data) => {
                    
                    this.getMeas();  
                    this.hideMeaModal();  
                    this.asyncGetMeas();
                    this.mea_text = "";
                    this.mea_category_id = ""; 
                },
                error: (error) => {
                     
                }, 
            })
            .done(function (data) { 
               
            });
        },
        modifyMea: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/editmeas/' + this.mea_id; 
            let mea_text = $("#mea_text").val();//this.mea_text;
            let mea_category_id = $("#mea_category_id").val();//this.mea_category_id;
            var formData = {
                'mea_text'			:  mea_text,
                'mea_category_id': mea_category_id 
            };
            
            if((mea_text != "") && (mea_category_id != ""))
            {
                // process the form
                $.ajax({
                    type: 'POST',
                    url: url,
                    data: formData,
                    dataType: 'json',
                    encode: true,
                    success: (data) => {
                        
                        this.hideeditMeaModal(); 
                        this.getMeas();  
                        this.mea_text = "";
                        this.mea_category_id = ""; 
                    },
                    error: (error) => {
                        
                    }, 
                })
                .done(function (data) { 
                
                });
            }
        },
        delMea: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/deletemea/' + this.mea_id; 
             
            

                // process the form
                $.ajax({
                    type: 'GET',
                    url: url, 
                    dataType: 'json',
                    encode: true,
                    success: (data) => {
                        
                        
                        this.getMeas(); 
                        this.hidedeleteMeaModal();                          
                        this.asyncGetMeas(); 
                    },
                    error: (error) => {
                        
                    }, 
                })
                .done(function (data) { 
                
                }); 
        },
        getMea(id){
            let url = this.apiUrl + '/getmea/' + id; 
             this.mea_id = id;
             // process the form
             $.ajax( url )
            .done(function(resp) { 
                $('#mea_text').val(resp[0].mea_text); 
                $('#mea_category_id').val(resp[0].mea_category_id); 
            }) ;  
            
        }, 
        addNextstep: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/addnextstep/' + this.id; 
            
            var formData = {
                'nextstep'			: this.nextstep,  
                "period_id": this.model.period_id 
            };
           
            
            // process the form
            $.ajax({
                type: 'POST',
                url: url,
                data: formData,
                dataType: 'json',
                encode: true,
                success: (data) => {
                    
                    this.getNextsteps();  
                    this.hideNextstepModal(); 
                    this.nextstep = ""; 
                },
                error: (error) => {
                     
                }, 
            })
            .done(function (data) { 
               
            });
        },
        modifyNextstep: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/editnextstep/' + this.nextstep_id; 
            let nextstep = $("#nextstep").val(); 
            this.nextstep; 
 
             
            var formData = {
                'nextstep'			:  nextstep, 
            };
           
            if((nextstep != "") )
            {

                // process the form
                $.ajax({
                    type: 'POST',
                    url: url,
                    data: formData,
                    dataType: 'json',
                    encode: true,
                    success: (data) => {
                        
                        
                        this.getNextsteps(); 
                        this.hideeditNextstepModal();  
                        this.nextstep = ""; 
                    },
                    error: (error) => {
                        
                    }, 
                })
                .done(function (data) { 
                
                });
            }
        },
        delNextstep: function () 
        {
            event.preventDefault();
            let url = this.apiUrl + '/deletenextstep/' + this.nextstep_id; 
             
            

                // process the form
                $.ajax({
                    type: 'GET',
                    url: url, 
                    dataType: 'json',
                    encode: true,
                    success: (data) => {
                        
                        
                        this.getNextsteps(); 
                        this.hidedeleteNextstepModal();   
                    },
                    error: (error) => {
                        
                    }, 
                })
                .done(function (data) { 
                
                }); 
        },
        getNextstep(id){
            let url = this.apiUrl + '/getnextstep/' + id; 
             this.nextstep_id = id;
             // process the form
             $.ajax( url )
            .done(function(resp) { 
                $('#nextstep').val(resp[0].nextstep);  
            }) ;  
            
        },  
       submitReports: function () {

            console.log("Data at submission:", JSON.parse(JSON.stringify(this.model)));

            event.preventDefault(); 

            let userName = this.getLoggedInUserName().replace(/'/g, "");
            this.model.approved = '0';
            let url = this.apiUrl + '/addreportsecretariat/' + this.id + "?period_id=" + this.model.period_id + "&loggedInUserId=" + this.getLoggedInUserId() + "&loggedInUserName=" + userName + "&loggedInUserEmail=" + this.getLoggedInUserEmail();

            var formData = {
                "period_id": this.model.period_id,
                "approved": '0'
            }; 
            
            console.log("Submitting to URL:", url);
            console.log("Form Data:", formData);
            console.log("period_id:", this.model.period_id);
            console.log("loggedInUserId:", this.getLoggedInUserId());
            console.log("loggedInUserName:", userName);
            console.log("loggedInUserEmail:", this.getLoggedInUserEmail());
            console.log("What submitteding:", JSON.parse(JSON.stringify(this.model)));
            
            // process the form
            $.ajax({
                type: 'POST',
                url: url,
                data: formData,
                dataType: 'json',
                encode: true,
                
                success: (data) => {
                    this.submittingInfo = false;

                    if (data.success) {
                        alert("Report Saved successfully.");
                        window.location.href = '/monitoring';
                        this.submittingMessage = "<span style='color: green;'>" + (this.id > 0 ? 'Saved' : 'saved') + " successfully.</span>";
                    } else {
                        alert("Error occurred: " + data.message + "");
                        this.submittingMessage = "<span style='color: red;'>Error occurred: " + data.message + "</span>";
                    }
                },
                error: (error) => {
                    console.log("Submit error:", error);
                    this.submittingInfo = false;

                    // Log the full error response
                    console.log("Error response details:", error);

                    // Check for specific properties in the error object
                    if (error && error.responseJSON && error.responseJSON.message) {
                        alert("Error occurred: " + error.responseJSON.message);
                        this.submittingMessage = "<span style='color: red;'>Error occurred: " + error.responseJSON.message + "</span>";
                    } else {
                        // Fallback in case message is not available
                        alert("Error occurred: " + JSON.stringify(error));
                        this.submittingMessage = "<span style='color: red;'>Error occurred: " + JSON.stringify(error) + "</span>";
                    }
                },
            })
            .done(function (data) { 
               
            });


 
         }, 

        saveEditReports2: function () {
            let buttonName = document.activeElement.name;

            //if (confirm("Are you sure you want to submit?")) {
            this.savingInfo = true;
            this.processingMessage = '';
            var thisRef = this;

           /* if (!this.$refs.form.checkValidity()) {
                this.savingInfo = false;
                return
            }*/

            this.processingMessage = "<span style='color: orange;'>Saving report ...</span>";
            // let url = this.apiUrl + '/addreportsecretariat/' + this.id + "?period_id=" + this.model.period_id + "&loggedInUserId=" + this.getLoggedInUserId() + "&loggedInUserName=" + this.getLoggedInUserName() + "&loggedInUserEmail=" + this.getLoggedInUserEmail();

            let url = this.apiUrl + '/addreportsecretariat/' + this.id + "?period_id=" + this.model.period_id + "&loggedInUserId=" + this.getLoggedInUserId() + "&loggedInUserName=" + encodeURIComponent(this.getLoggedInUserName()) + "&loggedInUserEmail=" + encodeURIComponent(this.getLoggedInUserEmail());

            fetch(url, {
                method: 'post',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(this.model)
            })
                .then((res) => {
                    if (!res.ok) {
                        throw new Error("HTTP status " + res.status);
                    }
                    return res.json();
                })
                .then(res => {
                    this.savingInfo = false;
                    if (res.success) {
                        if (buttonName == 'submittedButton') {
                            this.showMsgBoxTwo();
                        } else {
                          this.processingMessage = "<span style='color: green;'>" + (this.id > 0 ? 'Saved' : 'saved') + " successfully.</span>";  
                        }
                    } else {
                        if (buttonName == 'submittedButton') {
                            this.showMsgBoxTwo();
                        } else {
                            this.processingMessage = "<span style='color: red;'>Error occurred: " + res.message + "</span>";
                        }
                    }
                    setTimeout(function () {
                        thisRef.processingMessage = "";
                    }, 2000);
                }).catch(error => {
                    this.savingInfo = false;
                    this.processingMessage = "<span style='color: red;'>Error occurred: " + error + "</span>";
                    setTimeout(function () {
                        thisRef.processingMessage = "";
                    }, 2000);
                });
            // }
        }
    },
}
</script>
<style href="https://fonts.googleapis.com/css?family=Roboto" rel="stylesheet"></style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style href="https://fonts.googleapis.com/css?family=Roboto" rel="stylesheet"></style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.card-body {
    padding: 0px;
}

.ql-editor {
    min-height: 130px;
    font-size: 12px;
}

.nav-item {
    font-size: small !important;
    border-bottom: none !important;
    background-color: rgb(235 235 235) !important;
    border-bottom: 2px solid white;
}

.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
    color: #fff !important;
}

.li {
    display: list-item;
    border-bottom: gray;
    text-align: -webkit-match-parent;
}

.multiselect__tag {
    background-color: rgb(0, 173, 238);
}

.emptySelect .multiselect__content li:first-child {
    display: block !important;
}

.emptySelect .multiselect__content li:last-child {
    display: none !important;
}

.quillWrapper {
    max-width: 560px !important;
}

.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
    background-color: none !important;
}

.secreporting {
    margin: auto !important;
}

.row-container {
    height: 46px !important;
    width: 306px !important;
}

.card-header {
    padding: 0rem 0rem !important;
    margin-bottom: 0;
    background-color: rgba(0, 0, 0, 0.03);
    border-bottom: none;
}

.nav-pills .nav-link {
    border-radius: unset !important;
}

/** Data Table Styles **/
/*Table Hover color change*/
.dataTable tbody tr.highlightrow {
    background-color: #E3EBF5 !important;
    cursor: pointer;
}

table.dataTable tbody tr {
    cursor: pointer;
}

table.dataTable {
    margin-left: 15px;
}

.dataTable table thead tr th.sorting_asc:before,
.dataTable table thead tr th.sorting_desc:before {
    display: block;
    float: right;
    color: #fff;
    font-family: 'Entypo';
    content: '\e876';
    font-size: 16px;
}

.dataTable table thead tr th.sorting_asc,
.dataTable table thead tr th.sorting_desc {
    color: #fff;
    background-color: #a2bede;
}


.dataTable .dataTables_filter>label input {
    border: 1px solid #fff;
    background-color: #ccc;
    color: #003471;
}

.table-bordered>thead>tr>th,
.table-bordered>thead>tr>td,
.table-bordered>tbody>tr>td {
    border-color: #e7e7e7;
    height: 20px;
    padding: 5px;
}

.table-bordered>tbody>tr.footer {
    font-weight: bold;
}

.table-bordered>thead>tr>th,
.table-bordered>thead>tr>td {
    text-align: center;
}

.dataTable .dataTables_length,
.dataTable .dataTables_filter,
.dataTable .dataTables_info,
.dataTable .dataTables_processing,
.dataTable .dataTables_paginate {

    color: #003471;
}

.dataTable tbody tr:nth-child(even) {
    background: #fff
}

.dataTable tbody tr:nth-child(odd) {
    background: #fff
}

.dataTable {
    opacity: 0.85;
}

.pagination>.disabled>span,
.pagination>.disabled>span:hover,
.pagination>.disabled>span:focus,
.pagination>.disabled>a,
.pagination>.disabled>a:hover,
.pagination>.disabled>a:focus,
.pagination>li>a,
.pagination>li>span {
    border-color: #404041;
    color: #000;
    background: #e7e7e7;
    /* Old browsers */
    background: -moz-linear-gradient(top, #e7e7e7 0%, #e3e3e3 1%, #e7e7e7 2%, #fdfdfd 3%, #ffffff 5%, #fefefe 6%, #e2e2e2 7%, #e0e0e0 8%, #e6e6e6 9%, #e0e0e0 10%, #d7d7d7 11%, #cccccc 33%, #c9c9c9 35%, #cbcbcb 36%, #c7c7c7 40%, #c9c9c9 41%, #c5c5c5 45%, #c0c0c0 57%, #bbbbbb 64%, #bababa 67%, #bcbcbc 69%, #b8b8b8 71%, #bababa 72%, #b5b5b5 77%, #b4b4b4 83%, #aeaeae 91%, #b0b0b0 92%, #acacac 93%, #b0b0b0 95%, #ababab 96%, #9e9e9e 97%, #989898 98%, #9b9b9b 99%, #9a9a9a 100%);
    /* FF3.6+ */
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #e7e7e7), color-stop(1%, #e3e3e3), color-stop(2%, #e7e7e7), color-stop(3%, #fdfdfd), color-stop(5%, #ffffff), color-stop(6%, #fefefe), color-stop(7%, #e2e2e2), color-stop(8%, #e0e0e0), color-stop(9%, #e6e6e6), color-stop(10%, #e0e0e0), color-stop(11%, #d7d7d7), color-stop(33%, #cccccc), color-stop(35%, #c9c9c9), color-stop(36%, #cbcbcb), color-stop(40%, #c7c7c7), color-stop(41%, #c9c9c9), color-stop(45%, #c5c5c5), color-stop(57%, #c0c0c0), color-stop(64%, #bbbbbb), color-stop(67%, #bababa), color-stop(69%, #bcbcbc), color-stop(71%, #b8b8b8), color-stop(72%, #bababa), color-stop(77%, #b5b5b5), color-stop(83%, #b4b4b4), color-stop(91%, #aeaeae), color-stop(92%, #b0b0b0), color-stop(93%, #acacac), color-stop(95%, #b0b0b0), color-stop(96%, #ababab), color-stop(97%, #9e9e9e), color-stop(98%, #989898), color-stop(99%, #9b9b9b), color-stop(100%, #9a9a9a));
    /* Chrome,Safari4+ */
    background: -webkit-linear-gradient(top, #e7e7e7 0%, #e3e3e3 1%, #e7e7e7 2%, #fdfdfd 3%, #ffffff 5%, #fefefe 6%, #e2e2e2 7%, #e0e0e0 8%, #e6e6e6 9%, #e0e0e0 10%, #d7d7d7 11%, #cccccc 33%, #c9c9c9 35%, #cbcbcb 36%, #c7c7c7 40%, #c9c9c9 41%, #c5c5c5 45%, #c0c0c0 57%, #bbbbbb 64%, #bababa 67%, #bcbcbc 69%, #b8b8b8 71%, #bababa 72%, #b5b5b5 77%, #b4b4b4 83%, #aeaeae 91%, #b0b0b0 92%, #acacac 93%, #b0b0b0 95%, #ababab 96%, #9e9e9e 97%, #989898 98%, #9b9b9b 99%, #9a9a9a 100%);
    /* Chrome10+,Safari5.1+ */
    background: -o-linear-gradient(top, #e7e7e7 0%, #e3e3e3 1%, #e7e7e7 2%, #fdfdfd 3%, #ffffff 5%, #fefefe 6%, #e2e2e2 7%, #e0e0e0 8%, #e6e6e6 9%, #e0e0e0 10%, #d7d7d7 11%, #cccccc 33%, #c9c9c9 35%, #cbcbcb 36%, #c7c7c7 40%, #c9c9c9 41%, #c5c5c5 45%, #c0c0c0 57%, #bbbbbb 64%, #bababa 67%, #bcbcbc 69%, #b8b8b8 71%, #bababa 72%, #b5b5b5 77%, #b4b4b4 83%, #aeaeae 91%, #b0b0b0 92%, #acacac 93%, #b0b0b0 95%, #ababab 96%, #9e9e9e 97%, #989898 98%, #9b9b9b 99%, #9a9a9a 100%);
    /* Opera 11.10+ */
    background: -ms-linear-gradient(top, #e7e7e7 0%, #e3e3e3 1%, #e7e7e7 2%, #fdfdfd 3%, #ffffff 5%, #fefefe 6%, #e2e2e2 7%, #e0e0e0 8%, #e6e6e6 9%, #e0e0e0 10%, #d7d7d7 11%, #cccccc 33%, #c9c9c9 35%, #cbcbcb 36%, #c7c7c7 40%, #c9c9c9 41%, #c5c5c5 45%, #c0c0c0 57%, #bbbbbb 64%, #bababa 67%, #bcbcbc 69%, #b8b8b8 71%, #bababa 72%, #b5b5b5 77%, #b4b4b4 83%, #aeaeae 91%, #b0b0b0 92%, #acacac 93%, #b0b0b0 95%, #ababab 96%, #9e9e9e 97%, #989898 98%, #9b9b9b 99%, #9a9a9a 100%);
    /* IE10+ */
    background: linear-gradient(to bottom, #e7e7e7 0%, #e3e3e3 1%, #e7e7e7 2%, #fdfdfd 3%, #ffffff 5%, #fefefe 6%, #e2e2e2 7%, #e0e0e0 8%, #e6e6e6 9%, #e0e0e0 10%, #d7d7d7 11%, #cccccc 33%, #c9c9c9 35%, #cbcbcb 36%, #c7c7c7 40%, #c9c9c9 41%, #c5c5c5 45%, #c0c0c0 57%, #bbbbbb 64%, #bababa 67%, #bcbcbc 69%, #b8b8b8 71%, #bababa 72%, #b5b5b5 77%, #b4b4b4 83%, #aeaeae 91%, #b0b0b0 92%, #acacac 93%, #b0b0b0 95%, #ababab 96%, #9e9e9e 97%, #989898 98%, #9b9b9b 99%, #9a9a9a 100%);
    /* W3C */
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#e7e7e7', endColorstr='#9a9a9a', GradientType=0);
    /* IE6-9 */
}

body .pagination>.active>a,
body .pagination>.active>span,
body .pagination>.active>a:hover,
body .pagination>.active>span:hover,
body .pagination>.active>a:focus,
body .pagination>.active>span:focus {
    background-color: #fff;
    color: #000;
}

.dataTable .dataTables_info,
.dataTable .dataTables_paginate {
    padding: 10px 0px;
    border: 0px solid #ebebeb;
    border-top: 0;
    opacity: 0.9;
    height: 47px;
}

/** End Data Table Styles **/
.modal-content {
    width: 150% !important;
}
</style>